{
  "COMMON": {
    "CATEGORIES": "Categorieen"
  },
  "INCIDENT_NOTICE": {
    "TITLE": "We vragen nooit om je wachtwoord of kaartgegevens.",
    "BODY": "Op 1 november ontvingen sommige gebruikers een nepmelding. Heb je je gegevens gedeeld? Wijzig dan je wachtwoord en lees ons advies.",
    "READ_MORE": "Lees meer",
    "CLOSE": "Sluiten"
  },
  "COMPONENTS": {
    "VERTICAL_LINK_BOX": {
      "HEADER_TITLE": "Waar zoek je hulp bij?",
      "HEADER_SUBTITLE": "Selecteer een type klus"
    },
    "ACTIVITY": {
      "HEADER": "Dit gebeurt er nu op Handyhand",
      "CLOSE": "Sluit venster",
      "NEW_USER": "$$fullname$$ is lid geworden van Handyhand",
      "NEW_HH": "$$fullname$$ heeft een profiel aangemaakt",
      "NEW_TASK": "Nieuwe klus: \"$$taskname$$\"",
      "NEW_BID": "$$fullname$$ heeft een bod gedaan op \"$$taskname$$\"",
      "TASK_COMPLETED": "De klus \"$$taskname$$\" is zojuist voltooid",
      "TASK_ACCEPTED": "Een bod op \"$$taskname$$\" is geaccepteerd",
      "HH_UPDATED": "$$fullname$$ heeft zijn profiel bijgewerkt!",
      "NEW_REVIEW": "$$fullname$$ heeft een 5-sterren beoordeling ontvangen",
      "HH_VISITED": "$$fullname$$ heeft de klus \"$$taskname$$\" bekeken",
      "OFFER_COMMENT": "$$fullname$$ heeft gereageerd op \"$$taskname$$\"",
      "TASK_COMMENT": "$$fullname$$ heeft gereageerd op \"$$taskname$$\"",
      "NEW_PAYMENT": "Een bod is geaccepteerd",
      "VIEW_PROFILE": "Bekijk profiel",
      "VIEW_TASK": "Bekijk klus"
    },
    "CHANGELOG": {
      "TITLE": "Updates op het Handyhand platform",
      "SUBTITLE": "Blijf op de hoogte van de nieuwste verbeteringen, belangrijke informatie en nieuwe functies van het Handyhand platform",
      "USER_SEGMENTS": "Gebruikerstypes",
      "CATEGORIES": "Categorieen",
      "IMPORTANT": "Belangrijk",
      "DANISH": "Deens",
      "ENGLISH": "Engels",
      "SEARCH_PLACEHOLDER": "Zoek in changelog...",
      "CLEAR_FILTERS": "Wis alle filters",
      "NO_RESULTS": "Geen resultaten gevonden",
      "CHANGE_FILTERS": "Probeer je filterinstellingen aan te passen om meer resultaten te zien."
    },
    "CHATBOT": {
      "WELCOME_TOOLTIP": "Hallo! Ik kan helpen met klussen, vragen en prijsschattingen. Stel gerust je vraag!",
      "HEADER_TITLE": "Handyhand Assistent",
      "INPUT_PLACEHOLDER": "Typ hier je bericht...",
      "CREATE_TASK_BUTTON": "Maak klus aan",
      "BACK_TO_CHAT": "Terug naar chat",
      "PRE_STEP_INTRO": "Ik kan je helpen met:",
      "BACK_BUTTON": "Terug",
      "BOT_NAME": "Handyhand Bot",
      "CREATE_TASK_NOW": "Maak de klus aan",
      "GET_PRICE_ESTIMATE": "Krijg een prijsschatting",
      "IS_THIS_CORRECT": "Is dit correct?",
      "CONFIRM_YES": "Ja",
      "CONFIRM_NO": "Nee",
      "CHECKING_FAQ": "Veelgestelde vragen controleren...",
      "ERROR_START": "Sorry, ik kon de chat niet starten. Probeer het later opnieuw.",
      "ERROR_SEND": "<p class=\"error-message\">Sorry, er ging iets mis. Probeer het opnieuw.</p>",
      "MESSAGE_MARKERS": {
        "TASK_TITLE_COLON": "Titel van de klus:",
        "TASK_DESCRIPTION_COLON": "Beschrijving van de klus:",
        "CONFIRM_TOKEN": "[[HH_CONFIRM]]"
      },
      "PRE_STEP_OPTIONS": {
        "PRICE": {
          "ID": "prijs",
          "TITLE": "Budget calculator",
          "DESCRIPTION": "Krijg prijsschattingen in seconden"
        },
        "HELP": {
          "ID": "help",
          "TITLE": "Chat",
          "DESCRIPTION": "Hulp bij vragen, budget en aanmaken"
        },
        "TASK": {
          "ID": "klus",
          "TITLE": "Een klus aanmaken",
          "DESCRIPTION": "Maak direct een klus aan"
        }
      }
    },
    "HOW_IT_WORKS_DIALOG": {
      "TITLE": "Zo werkt het",
      "STEP_BY_STEP_TAB": "Stap voor stap",
      "VIDEO_TAB": "Bekijk video",
      "MAIN_TITLE": "Maak je klus aan in enkele minuten",
      "STEP_1": {
        "TITLE": "Beschrijf je klus",
        "DESCRIPTION": "Beschrijf de klus die je uitgevoerd wilt hebben."
      },
      "STEP_2": {
        "TITLE": "Ontvang offertes",
        "DESCRIPTION": "Je ontvangt meestal de eerste offertes binnen 5-10 minuten."
      },
      "STEP_3": {
        "TITLE": "Laat je klus uitvoeren",
        "DESCRIPTION": "De klus wordt uitgevoerd en je betaalt pas als je tevreden bent."
      },
      "CREATE_TASK_BUTTON": "Maak nu een klus aan"
    },
    "BLOG": {
      "META_TITLE": "Handyhand Artikelen",
      "META_DESC": "Artikelen, tips en trucs voor huis, tuin en doe-het-zelf",
      "SNIPPET_FALLBACK": "Lees meer over dit onderwerp..."
    },
    "EARNING_AVERAGE": {
      "WEEK_TASKS": " aan klussen per week",
      "MONTH": "per maand",
      "PRICE_AVG_1": "Gebaseerd op gemiddelde prijzen van",
      "PRICE_AVG_2": "klussen. Prijzen kunnen variëren"
    },
    "EARNINGS_CALCULATOR": {
      "META_TITLE": "Freelance loon calculator | Controleer je potentieel",
      "META_DESC": "Ontdek je potentiële inkomsten als freelancer op Handyhand met onze geavanceerde loon calculator! Door gemiddelde lonen van duizenden klussen op ons platform te analyseren, zorgen we ervoor dat je een realistische schatting krijgt van wat je inkomen zou kunnen zijn. Ben je klaar om je eigen baas te worden? Probeer de calculator en ontdek wat je vaardigheden waard zijn op het meesttoonaangevende dienstenplatform van Nederland.",
      "TITLE": "Loon als freelancer",
      "SUB_TITLE": "Bereken wat je vergoeding kan zijn! Met de calculator krijg je een realistische schatting van hoeveel je per week of per maand kunt verdienen!",
      "TXT_WRAPPER": " <p>\n Met onze freelance loon calculator kun je zien hoeveel geld je per maand kunt verdienen op Handyhand! Als je je ooit hebt afgevraagd hoeveel geld je kunt verdienen als bijvoorbeeld fotograaf of door op huisdieren te passen, kun je dat hier te weten komen. Zo weet je wat je vaardigheden waard zijn en hoeveel klussen je moet voltooien om je financiële doelen te bereiken. \nElke dag worden er klussen aangemaakt op Handyhand waarvoor jij misschien de juiste vaardigheden hebt om ze op te lossen, dus waarom niet geld verdienen met iets waar je goed in bent! Je kunt zelf bepalen of het parttime, fulltime of gewoon af en toe is wanneer je zin hebt. Maak je gebruiker aan op onze digitale marktplaats, bied op klussen en begin vandaag nog met geld verdienen!</p>",
      "TXT_CALC": "Onze freelance loon calculator geeft je de mogelijkheid om de \n waarde van je vaardigheden te ontdekken",
      "TXT_1": "\n <h2>Waar kun je de calculator voor gebruiken?</h2>\n<p>\n Veel Nederlanders ervaren dat de stijgende kosten van levensonderhoud hun financiën beïnvloeden, en er niet zoveel geld meer over is om van te leven als voorheen. Met stijgende prijzen voor\n        hypotheekrente, boodschappen, benzine en energie blijft er elke maand minder geld over. Dit betekent dat de meeste mensen meer moeten betalen om\n        hun levensstandaard te kunnen behouden, en mogelijk extra geld nodig hebben om bij te dragen aan hun inkomen om op die manier  de dagelijkse uitgaven bij te houden.\n      </p>\n      <p>\n       Daarom hebben we een freelance loon calculator gemaakt die je kunt gebruiken om beter te begrijpen hoe je wat extra kunt verdienen met je vaardigheden en capaciteiten. Of je nu groene vingers hebt en expert bent in alles wat met tuinwerk te maken heeft, of precies weet welke schoonmaakmiddelen je moet gebruiken om elke vlek te verwijderen, er is een klus voor jou op Handyhand. Deze nieuwe tool neemt het giswerk weg, zodat je je vergoeding en verdienpotentieel beter kunt inschatten en controle kunt nemen over je inkomen en levensstijl.\n      </p>\n      <p>\n        Wil je weten hoeveel je kunt verdienen? Kies uit een van de meer dan 40 verschillende categorieën, zoals <span><a href='https://handyhand.nl/verhuizen/verhuizer/hh'>verhuishulp</a></span>,\n        <span><a href='https://handyhand.nl/tuin/tuinwerk/hh'>tuinwerk</a></span> of <span><a href='https://handyhand.nl/schoonmaak/hh',>schoonmaak</a></span>, en voer vervolgens het volgende in:\n      </p>\n      <ul>\n        <li>\n          <p>Aantal klussen per week</p>\n        </li>\n        <li>\n          <p>Frequentie - wekelijks of maandelijks</p>\n        </li>\n      </ul>\n      <p>\n        ...en voilà! De calculator gebruikt het gemiddelde van de klusprijs gebaseerd op onze marktplaatsgegevens.\n      </p>\n",
      "USP_1": "Ben je een geboren klusser?",
      "USP_2": "Gebruik je vaardigheden en verdien tot €3.500 per maand met 5 klussen \n per week.",
      "EARN_UP": "Verdien tot",
      "AMOUNT_28": "€2.800",
      "AMOUNT_35": "€3.500",
      "AMOUNT_38": "€3.800",
      "MONTH": "Per maand",
      "CLEAN_USP": "Ben je goed in schoonmaken?",
      "CLEAN_DESC": "Of het nu gaat om routine- of eindschoonmaak, je kunt geld verdienen met\n          je schoonmaakvaardigheden en tot €2.800 per maand verdienen als \n je 5 klussen per week uitvoert.",
      "GREEN_USP": "Heb je groene vingers?",
      "GREEN_DESC": "Hou je van tuinwerk, planten of gewoon buiten in de natuur zijn? Verdien\n          tot €3.800 per maand met 5 tuinklussen per week.",
      "CATEGORIES": {
        "ADMINISTRATION": "Administratie",
        "AELDREHJAELP": "Ouderenzorg",
        "BOERNEPASNING": "Kinderopvang",
        "BROLAEGNING": "Bestrating",
        "BYGGE_PROJEKTER": "Bouwprojecten",
        "CHAUFFOER": "Chauffeur",
        "DIGITALT_DESIGN": "Digitaal ontwerp",
        "DYREPASNING": "Dierenverzorging",
        "ELEKTRIKER": "Elektricien",
        "FLYTTEHJAELP": "Verhuishulp",
        "FOTOGRAF": "Fotograaf",
        "FRISOER": "Kapper",
        "GULVARBEJDE": "Vloerwerk",
        "HANDYMAN": "Klusjesman",
        "HAVEARBEJDE": "Tuinwerk",
        "HJAELP_MOBIL_PC_TV": "Hulp bij mobiel, pc en tv",
        "INDRETNINGSARKITEKT": "Interieurarchitect",
        "IVAERKSAETTERHJAELP": "Startersbegeleiding",
        "LASESMED": "Slotenmaker",
        "MADLAVNING": "Koken",
        "MALER": "Schilder",
        "MASSOER": "Masseur",
        "MEKANIKER": "Monteur",
        "MOEBEL_REPARATION": "Meubelreparatie",
        "MOEBELSAMSLING": "Meubelmontage",
        "MURER": "Metselaar",
        "NEDRIVNING": "Sloop",
        "RENGOERING": "Schoonmaak",
        "REPARATION_BIL_BAAD_CYKEL": "Reparatie auto, boot en fiets",
        "RYDNING": "Opruimen / afval ophalen",
        "SANERING": "Sanering",
        "SERVERING_FESTHJAELP": "Bediening of feesthulp",
        "SKADEDYRSBEKAEMPELSE": "Ongediertebestrijding",
        "SMED": "Smid / lasser",
        "SYNING": "Naaiwerk",
        "TAGARBEJDE": "Dakwerk",
        "TEKSTFORFATTER": "Tekstschrijver",
        "TOEMRER_SNEDKER": "Timmerman & schrijnwerker",
        "UNDERVISNING": "Bijles / lesgeven",
        "VVS": "Loodgieter (sanitair)"
      },
      "ENGINE": {
        "EARN": "Hoeveel kun je verdienen?",
        "CHOOSE_CAT": "Kies een categorie / vaardigheid",
        "REQ_CAT": "Je moet een categorie / vaardigheid kiezen",
        "W": "Met",
        "TASK_PR": "klussen per",
        "CALC_SALARY": "Bereken je loon",
        "EARN_POS": "Je kunt verdienen",
        "START": "Begin nu",
        "RESTART": " Herstart de calculator",
        "CALC_1": " Gebaseerd op gemiddelde prijzen van ",
        "CALC_2": "klussen. Prijzen kunnen variëren",
        "ERROR_FETCH_TASKS": "Kon klussen niet laden. Probeer het opnieuw.",
        "ERROR_NO_PRICE_DATA": "Geen prijsgegevens beschikbaar voor deze categorie."
      }
    },
    "FAQ": {
      "Q1": "Relevante",
      "Q2": "vragen",
      "Q3": "Vragen en antwoorden",
      "FULL": "FAQ - veelgestelde vragen"
    },
    "HANDYHANDER_LEVELS": {
      "TITLE": "Hoe werken Handyhand niveaus",
      "META_DESC": "Handyhand niveaus zijn er om jou meer voordelen te bieden aan wanneer je klussen uitvoert op Handyhand. Wanneer je een bepaald bedrag verdient door klussen uit te voeren, kun je de servicekosten op toekomstige klussen verlagen met Handyhand niveaus.",
      "H1": "Hoe werken Handyhand niveaus ",
      "H2": "Hoe wordt mijn niveau berekend? ",
      "H3": "Wat is mijn \"voltooiingspercentage\"?",
      "H4": "Wat zijn mijn \"inkomsten\"?",
      "H5": "Waar kan ik meer informatie vinden?",
      "T1": "Handyhand niveaus zijn er om jou meer voordelen te bieden aan wanneer je  klussen uitvoert op Handyhand. Wanneer je een bepaald bedrag verdient door klussen uit te voeren, kun je de servicekosten op toekomstige klussen verlagen met Handyhand niveaus.",
      "T2": "Je wordt beloond met verschillende niveaus wanneer je geld verdient door klussen uit te voeren op Handyhand. De niveaus zijn onderverdeeld in brons, zilver, goud en platina. Een hoger niveau geeft lagere servicekosten op toekomstige klussen.",
      "T3": "Je niveau wordt bepaald door twee verschillende cijfers:",
      "T4": "1. Je voltooiingspercentage, d.w.z. hoe goed je bent geweest in het voltooien van de klussen waarvoor je bent geaccepteerd uit je laatste 20 toegewezen klussen op het platform.",
      "T5": "2. Je inkomsten van de afgelopen 30 dagen, d.w.z. hoeveel je hebt verdiend in de afgelopen 30 dagen.",
      "T6": "Elk niveau heeft een minimumvereiste voor inkomsten en voltooiingspercentage. Je moet aan deze vereisten voldoen om naar het bijbehorende niveau te gaan.",
      "T7": "Hier zie je de tarieven voor elk niveau:",
      "T8": "Je voltooiingspercentage is een weerspiegeling van hoe goed je je verplichtingen bent nagekomen voor je laatste 20 toegewezen klussen.",
      "T9": "Voltooiingspercentage wordt berekend door alle voltooide klussen te vergelijken met alle geannuleerde klussen in de laatste 20 toegewezen klussen. Op deze manier is er een redelijke buffer ingebouwd als er onvermijdelijke annuleringen zijn (Dit kan altijd gebeuren!).",
      "T10": "Een voltooiingspercentage kan momenteel in een van vier niveaus vallen: Slecht, Oké, Goed en Fantastisch. Hoe meer klussen je voltooit van je laatste 20 toegewezen klussen, hoe beter je voltooiingspercentage wordt.",
      "T11": "Je inkomstscore is gebaseerd op je totale inkomsten over de afgelopen 30 dagen.",
      "T12": "Elke keer dat een klusgever de betaling aan jou vrijgeeft, wordt het bedrag bij je totaal opgeteld en blijft het de komende 30 dagen staan.",
      "T13": "Je kunt meer informatie vinden over hoe niveaus en kosten werken in dit ",
      "T14": "dat ook veelgestelde vragen bevat. Neem gerust contact op met support als je feedback of suggesties hebt.",
      "A_1": "artikel",
      "BRONZE": "Brons",
      "FEE_LABEL": "{{fee}} servicekosten",
      "BRONZE_COM": "Slecht voltooiingspercentage op de laatste 20 klussen",
      "BRONZE_EARN": "Verdien minder dan €380 in de afgelopen 30 dagen",
      "SILVER": "Zilver",
      "SILVER_COM": "Oké voltooiingspercentage op de laatste 20 klussen",
      "SILVER_EARN": "Verdien meer dan €380 in de afgelopen 30 dagen",
      "GOLD": "Goud",
      "GOLD_COM": "Goed voltooiingspercentage op de laatste 20 klussen",
      "GOLD_EARN": "Verdien meer dan €1.150 in de afgelopen 30 dagen",
      "PLAT": "Platina",
      "PLAT_COM": "Fantastisch voltooiingspercentage op de laatste 20 klussen",
      "PLAT_EARN": "Verdien meer dan €2.300 in de afgelopen 30 dagen"
    },
    "HERO": {
      "TITLE": "Bekijk wat je kunt verdienen",
      "NEAR_Y": " bij jou in de buurt",
      "NATIONAL_LINK": "{{service}} in heel Nederland",
      "NEEDS": "voor al je behoeften",
      "FAST_CLEANING": "Vaste schoonmaak?",
      "BOOKING_TEXT_2": "Krijg €10 korting voor vaste schoonmaak met HappyHelper met de code:",
      "BOOKING_TEXT": "Begin hier",
      "CODE_COPIED": "Kortingscode gekopieerd! Je wordt nu doorgestuurd...",
      "BOOKING": "Boeken",
      "ALT": {
        "EYEBROW": "Het grootste klusplatform van Nederland",
        "TRUSTPILOT_EXCELLENT": "Uitstekend"
      }
    },
    "LINK_CONTAINER": {
      "IN": "in",
      "SERVICES_WORD": "diensten",
      "JOBS_WORD": "klussen",
      "RELATED_CITIES": "Gerelateerde steden",
      "OTHER": "Andere",
      "OTHER_REGIONS": "Andere regio's",
      "PLACES": "en plaatsen",
      "SERVICES": "Gerelateerde diensten",
      "REL": "GERELATEERD"
    },
    "PRICE_REVIEW": {
      "PARAGRAPH": "Bekijk alle beoordelingen die mensen je hebben gegeven.",
      "REPORT": "Rapporteer gebruiker",
      "LAT": "De laatste ",
      "REV": "Laatste beoordelingen",
      "GET_PRICE": "Ontvang een prijs"
    },
    "DAMAGE_COMPENSATION_LINE": {
      "TITLE": "Gratis schadevergoeding tot {{maxAmount}}",
      "LINK": "Zo werkt het"
    },
    "VALUE_LINE": {
      "SERVICE_COIN": "Voordeliger dan traditionele aanbieders",
      "SERVICE_TASK": "Grote en kleine klussen",
      "SERVICE_DAMAGE_COMPENSATION": "Gratis schadevergoeding",
      "SERVICE_DAMAGE_COMPENSATION_DESC": "We bieden gratis schadevergoeding die schade tot {{maxAmount}} dekt, zodat je met een gerust hart een Handyhand boekt.",
      "SERVICE_PAY": "Veilige contactloze betaling",
      "SERVICE_BOOKING": "Service dezelfde of volgende dag "
    },
    "DEEP_LINK_BUTTONS": {
      "HOW_IT_WORKS": "Hoe het werkt",
      "MEET_SOME_HANDYHANDS": "Wie biedt",
      "EXAMPLES": "Voorbeelden",
      "FAQ": "Vragen",
      "PRICES_AND_REVIEWS": "Prijzen en beoordelingen",
      "PRICES": "Prijzen",
      "REVIEWS": "Beoordelingen",
      "GOOD_TO_KNOW": "Goed om te weten",
      "WHY_HANDYHAND": "Waarom Handyhand"
    },
    "GLOBAL_SEARCH_ENGINE": {
      "PLACEHOLDER": "Zoek naar categorieën, gidsen, artikelen..."
    },
    "FLOATING_CTA": {
      "BUTTON": "Krijg een prijs binnen 2 minuten"
    },
    "CHECKLIST": {
      "DONE_PERCENT": "Voltooid:",
      "SELECT_LABEL": "Kies checklist:",
      "READ_MORE": "Lees meer",
      "SEE_GUIDE": "Zie gids:",
      "CREATE_TASK": "Maak de klus aan op Handyhand",
      "ADD_ITEM_PLACEHOLDER": "Nieuw punt",
      "ADD_ITEM_DESC_PLACEHOLDER": "Beschrijving (optioneel)",
      "ADD_ITEM_BUTTON": "Punt toevoegen",
      "EDIT_MODE_SAVE": "Wijzigingen opslaan",
      "EDIT_MODE_EDIT": "Checklist bewerken",
      "PRINT_PDF": "PDF afdrukken",
      "OPTIONS": {
        "WEDDING": "Bruiloft",
        "WEDDING_TODO": "Bruiloft checklist",
        "MOVING_OUT": "Uit huis gaan",
        "RENTAL_MOVE_IN": "Intrekken in huurwoning",
        "GARDEN": "Tuin",
        "CLEANING_EQUIPMENT": "Schoonmaakspullen",
        "CLEANING_SCHEDULE": "Schoonmaakschema",
        "AIRBNB_CLEANING": "Airbnb schoonmaak",
        "MOTORCYCLE_INSPECTION": "Motor keuring"
      }
    },
    "CUSTOM_CARD": {
      "READ_PRICE_GUIDE": "Lees de prijsgids",
      "SEE_ALL_PRICE_DATA": "Bekijk alle prijsdatagidsen"
    },
    "GENERIC_CARD": {
      "SEE_ALL_TIPS": "Bekijk alle tips"
    },
    "SPONSORED_BANNERS": {
      "GO_TO_WEBSITE": "Ga naar website",
      "HEADER_PREFIX": "Gesponsord"
    },
    "ASSOCIATED_TASKS": {
      "EXPAND_AREA_ARIA": "Gebied uitklappen"
    },
    "HOW_IT_WORKS_VIDEO": {
      "IFRAME_TITLE": "Zo werkt Handyhand"
    }
  },
  "GENERAL": {
    "ABOUT_US": "Over ons",
    "AS_TO": "Als klusgever",
    "BACK": "Terug",
    "BEST": "De beste",
    "COMPLETION_RATE": "Voltooiingspercentage",
    "CREATE_TASK": "Maak een klus aan",
    "HELP": "Hulp",
    "HELP_FOR": "Waar zoek je hulp voor?",
    "HELP_FOR_TXT": "Ik heb hulp nodig bij...",
    "HELP_NOW": "Vind nu gratis hulp",
    "SEARCH_SITE_PLACEHOLDER": "Doorzoek onze hele site...",
    "SEARCH_SUBMIT": "Zoeken",
    "HEADER_SEARCH_PLACEHOLDER": "Waar ben je naar op zoek?",
    "CLEANING_ONE_OFF": "Eenmalige schoonmaak",
    "CLEANING_SUBSCRIPTION": "Vaste schoonmaak",
    "CLEANING_FIND": "Vind schoonmaak",
    "DAMAGE_COMPENSATION": "Schadevergoeding",
    "TERMS": "Algemene voorwaarden",
    "PRIVACY": "Privacybeleid",
    "GUIDELINES": "Richtlijnen",
    "PRESS": "Pers",
    "OFF_NOW": "Ontvang gratis offertes",
    "SIMILAR_TASKS_BTN": "Maak een vergelijkbare klus aan",
    "OFF": "Ontvang offertes",
    "REQUEST_OFFER": "Vraag offerte aan",
    "CREATE_FREE": "Maak de klus gratis aan",
    "NO_TIME": "Het duurt minder dan 2 minuten en is gratis!",
    "FAQ": "FAQ - veelgestelde vragen",
    "REVIEW": "BEOORDELING",
    "SERVICE_IN_CAT": "Dienstverleners in de categorie: ",
    "WHY_FLEX": "Flexibiliteit",
    "PREV_TASK": "Eerdere klussen",
    "MEMBER": "Word lid",
    "OFFER_N": "Wat biedt",
    "SEL_TASK_TYPE": "Kies een type klus",
    "READ": "Lees meer",
    "INFO": "Info",
    "BEST_ASSOCIATED_USERS_SUB": "Handyhand is een marktplaats met geverifieerde Handyhanders en echte beoordelingen – klaar voor jouw klus",
    "TIME": {
      "WEEK": "week",
      "MONTH": "maand"
    },
    "WITHIN_AREA": "lost klussen op binnen \n de gebieden:",
    "WORTH_KNOW": "Goed om te weten",
    "WHY_DESC": " Kies de klussen die je wilt uitvoeren voor de mensen met wie je prettig\n                samenwerkt. Je hebt controle over je eigen agenda en kunt\n                zelf de balans tussen werk en privé vinden die voor jou het beste werkt.",
    "BTN": {
      "CATS": "Alle categorieën",
      "CAT_1": "Categorieën",
      "CREATE_TASK_NOW": "Maak nu een klus aan",
      "SEE_ALL": "Bekijk alle...",
      "SEE_MORE": "Bekijk meer...",
      "FIND_TASKS": "Bekijk klussen",
      "BTN_TASK4": "Probeer het nu"
    },
    "CONTROL": {
      "EXT": "Uitvouwen",
      "HIDE": "Verbergen"
    },
    "CUTS": {
      "EXPERT": ", van experts bij jou in de buurt.",
      "HERE": "hier",
      "FIND": "Vind",
      "READ_MORE_ABOUT": "Lees meer over het onderwerp",
      "FIND_A": "Vind een",
      "HELP_WITH": "Hulp bij",
      "FOR_TASK": " voor de klus",
      "NEAR_Y": " bij jou in de buurt",
      "NOW": "nu",
      "H_IN": "helpt met tuinwerk in",
      "HELP_FOR": "Je kunt hulp vinden voor",
      "IN": "en omgeving",
      "CREATE_TASK": "Maak een klus aan, ontvang offertes en laat de klus uitvoeren"
    },
    "CTA": {
      "HELP_TASK": "Wil je hulp bij het oplossen van een klus betreffende ",
      "HELP_OFFERED": " Op Handyhand bieden particulieren betaalbare hulp om klussen uit te voeren, je kunt\n        je klus hier gratis aanmaken en de Handyhanders laten reageren met offertes",
      "C_1": "Het is ",
      "C_2": "gratis",
      "C_3": "en duurt 2\n  minuten.",
      "SIGN_UP_NOW": "Meld je nu aan"
    },
    "LOADING": {
      "CREATING_TASK": "\"Klus aanmaken\" openen...",
      "REDIRECTING": "Doorsturen naar Handyhand..."
    }
  },
  "META": {
    "EARN": "Verdien geld met",
    "FIND_LOCAL": "Vind lokale"
  },
  "NAVIGATION": {
    "BTN": {
      "CREATE_TASK": "Maak klus aan",
      "TRY_NOW": "Probeer het nu",
      "CTA_START": "Begin nu",
      "BACK_TO_PLATFORM": "Terug naar het platform"
    },
    "TXT": {
      "ABOUT_US": "Over ons",
      "CREATE_TASK": "Maak een klus aan",
      "HOME": "Home",
      "HOW_IT_WORKS": "Hoe werkt het?",
      "LOGIN": "Inloggen",
      "SIGN_UP": "Aanmelden",
      "SEE_TASKS": "Bekijk klussen",
      "SEE_ALL_TASKS": "Bekijk alle klussen",
      "SEARCH_SITE": "Zoek op de site",
      "SEARCH_PLACEHOLDER": "Wat zoek je?"
    }
  },
  "PAGES": {
    "SECURITY_INCIDENT": {
      "META_TITLE": "Beveiligingsmelding: nepmeldingen op 1 november",
      "META_DESC": "Op zondag 1 november is een nep-pushmelding verstuurd naar een deel van de gebruikers van Handyhand. Lees wat er is gebeurd en wat je moet doen.",
      "EYEBROW": "Veiligheid",
      "TITLE": "Beveiligingsmelding: nepmeldingen op 1 november",
      "LEAD": "Op zondag 1 november rond 16.40 uur is een nep-pushmelding verstuurd naar een deel van onze gebruikers. Hier lees je wat er is gebeurd en wat je moet doen.",
      "STATUS_TITLE": "Status: ingedamd en onder toezicht",
      "STATUS_BODY": "We hebben de oorzaak gevonden, de nepmeldingen verwijderd, het probleem verholpen en extra beveiligingsmaatregelen toegevoegd. Het platform werkt normaal en we houden het nauwlettend in de gaten. We hebben het incident gemeld bij de politie en de Deense privacytoezichthouder (Datatilsynet).",
      "UPDATED": "Laatst bijgewerkt: 3 november 2026",
      "WARNING_TITLE": "Geef nooit je betaal- of inloggegevens via een link of telefonisch door",
      "WARNING_BODY": "We vragen nooit om je wachtwoord of kaartgegevens via een link of telefonisch. Controleer het webadres goed voordat je op een link klikt of inlogt: er moet {{domain}} staan. Ziet het er ook maar een beetje anders uit, klik dan niet en vul niets in.",
      "FAQ_TITLE": "Belangrijke informatie",
      "FAQ": {
        "ENTERED_DETAILS": {
          "QUESTION": "Ik heb op de link geklikt en mijn gegevens ingevuld. Wat moet ik doen?",
          "LOGIN": "Als je je inloggegevens hebt ingevuld, wijzig dan nu je wachtwoord op {{domain}}, en overal waar je dit wachtwoord gebruikt. Kun je niet inloggen? Gebruik dan \"Wachtwoord vergeten\" op de inlogpagina.",
          "CARD": "Als je je kaartgegevens hebt ingevuld, blokkeer dan je kaart, neem contact op met je bank en let op frauduleuze afschrijvingen.",
          "CHANGE_PASSWORD": "Wachtwoord wijzigen"
        },
        "ONLY_CLICKED": {
          "QUESTION": "Ik heb op de melding/link geklikt, maar verder niets gedaan. Zijn mijn gegevens in gevaar?",
          "ANSWER": "Als je op de link hebt geklikt, maar GEEN inloggegevens of kaartgegevens hebt ingevuld, hoor je bij de getroffen gebruikers, maar zijn je gegevens veilig. Je hoeft niets te doen."
        },
        "TASK_TODAY": {
          "QUESTION": "Ik heb vandaag een klus gepland - wat moet ik doen?",
          "ANSWER": "Handyhand is weer online, dus je kunt de informatie over je klus weer op het platform vinden. Onze excuses voor het ongemak terwijl het platform offline was.",
          "CALL_BEFORE": "Kun je de benodigde informatie nog steeds niet vinden, neem dan contact op met de klantenservice via",
          "CALL_AFTER": ". Zij proberen het contact tussen beide partijen te helpen leggen. Heb alsjeblieft geduld."
        },
        "NOT_RECEIVED": {
          "QUESTION": "Ik heb geen melding of bericht ontvangen, wat nu?",
          "ANSWER": "Je bent niet getroffen en je hoeft niets te doen."
        },
        "SITE_NOT_WORKING": {
          "QUESTION": "De website/app werkt bij mij nog steeds niet. Waarom?",
          "ANSWER": "Delen van Handyhand zijn uit veiligheidsoverwegingen tijdelijk offline gehaald en zijn nu weer online. Werkt er nog iets niet, laad de pagina dan opnieuw of log opnieuw in. Blijft het gebeuren, neem dan contact op met de klantenservice."
        },
        "WHICH_PARTS": {
          "QUESTION": "Welke delen van het platform waren getroffen?",
          "ANSWER": "De tijdelijke sluiting had gevolgen voor profielen, klussen en berichten. Alles is weer online. Onze excuses voor het ongemak."
        },
        "ACCOUNT_BLOCKED": {
          "QUESTION": "Is mijn account geblokkeerd?",
          "ANSWER": "Nee, het bericht kwam niet van ons en je account is niet geblokkeerd."
        }
      },
      "CTA_TITLE": "Heb je vandaag een klus?",
      "CTA_BODY": "Kun je de gegevens nog steeds niet vinden? Bel dan de klantenservice.",
      "CTA_BUTTON": "Bel {{phone}}",
      "CLOSING": "Voor de veiligheid van onze gebruikers kunnen we op dit moment niet meer informatie delen. Bedankt voor je begrip. We houden je op de hoogte."
    },
    "ABOUT_US": {
      "ABOUT_DESC": "In november 2018 werd Handyhand opgericht. Het begon met twee studenten die allebei een makkelijke manier misten om wat extra te verdienen naast hun studie. Saxo, een van de oprichters, leidt vandaag het bedrijf, dat bestaat uit een team van enthousiastelingen die gepassioneerd zijn over het concept",
      "ABOUT_DESC_2": "De inspiratie voor het platform ontstond uit Saxo's eigen vader, die werkte als klusjesman en altijd klaarstond met een helpende hand wanneer er problemen moesten worden opgelost in of buitenshuis. Zo iemand, vond hij, zou iedereen moeten kunnen inschakelen, en zo kwam Handyhand tot leven",
      "ABOUT_DESC_3": "Met vriendelijke groet,",
      "CONTACT_US_TITLE": "Neem contact met ons op",
      "CONTACT_US_DESC": "Je bent altijd welkom om ons een e-mail te sturen naar support@handyhand.nl als je meer wilt weten of hulp nodig hebt.",
      "CHRIS": "Krisztian Szabo - Ontwikkelaar",
      "CHRIS1": "\"Ons doel is om zoveel mogelijk waarde te creëren voor de samenleving\"",
      "HEADER_TITLE": "Over Handyhand",
      "HEADER_SUB": "Bij Handyhand willen we het makkelijker, voordeliger en veiliger maken om hulp te vinden voor dagelijkse klussen in lokale gemeenschappen.",
      "MEET_TEAM": "Team Handyhand",
      "PATRICK": "Patrick Sahlgren - CTO",
      "PATRICK1": "\"Ik hou ervan als ik software kan maken die mensen daadwerkelijk kunnen gebruiken\"",
      "SAXO": "Saxo Merrild - Oprichter",
      "SAXO1": "\"Als we mensen meer tijd en geld kunnen geven, dan hebben we gewonnen\"",
      "TITLE": "Wie is Handyhand?",
      "BODY_TXT_1": "Wij zijn een digitaal platform dat je veilig en eenvoudig met anderen verbindt. Iedereen die geboren is met twee linkerhanden, kan zo een lokale klusjesman ontmoeten. Een betrouwbaar netwerk is een van onze kernprioriteiten, en we zorgen ervoor dat HandyHand de betrouwbare schakel is tussen jou en de mensen die klaar staan om je te helpen.",
      "BODY_TXT_2": "Ons platform zorgt er voor dat de soms onoverzichtelijke en tijdrovende klussen in handen komen van degene die echt voldoening haalt uit het grondigschoonmaken, geboren is met groene vingers, of gewoon wat extra geld wil verdienen met klussen.",
      "TITLE_2": "Het platform",
      "BODY_TXT_3": "Het idee van een digitale ontmoetingsplaats voor klussers vindt zijn oorsprong in de jeugd van Saxo, de oprichter van Handyhand. Saxo kijkt met een glimlach terug op de dagen dat zijn vader, met een gereedschapsriem om zijn middel, door het hele dorp fietste om iedereen te helpen die hulp nodig had. Zo'n persoonlijke service, vond hij, zou iedereen moeten kunnen krijgen. Dat leidde tot de oprichting van Handyhand.",
      "BODY_TXT_4": "In de afgelopen jaren zijn de klussen op Handyhand geëvolueerd van voornamelijk typische klusjes in en rond het huis  naar een oneindig breed scala aan dagelijkse klussen; van het knippen van de nagels van je huisdier tot het monteren van een IKEA-kast. Bij ons is er plaats voor iedereen, ongeacht ras, geslacht, nationaliteit, beroep en vaardigheden, en alleen de verbeelding stelt grenzen aan wat de volgende klus zal zijn.",
      "TIME_LINE_TITLE": "Tijdlijn",
      "USERS": "leden",
      "ACQUIRED": "overgenomen",
      "TIME_LINE_SUBTITLE_1": "opgericht",
      "TIME_LINE_SUBTITLE_2": "gelanceerd",
      "TIME_LINE_SUBTITLE_3": "project",
      "TIME_LINE_1": "Het bedrijf Pinploy wordt opgericht door Saxo en een van zijn toenmalige medestudenten van de informatica-opleiding",
      "TIME_LINE_DATE_1": "November, 2018",
      "TIME_LINE_TITLE_1": "Het bedrijf Pinploy wordt opgericht",
      "TIME_LINE_2": "Het serviceplatform Pinploy wordt gelanceerd als website - pinploy.dk",
      "TIME_LINE_DATE_2": "April, 2020",
      "TIME_LINE_TITLE_2": "Website wordt gelanceerd",
      "TIME_LINE_3": "De twee oprichters werken fulltime en wijden al hun tijd aan de ontwikkeling van het platform",
      "TIME_LINE_DATE_3": "Augustus, 2021",
      "TIME_LINE_TITLE_3": "Fulltime aan het project",
      "TIME_LINE_4": "Met hulp van Krisztian wordt een bijbehorende iOS- en Android-app gelanceerd",
      "TIME_LINE_DATE_4": "Augustus, 2021",
      "TIME_LINE_TITLE_4": "iOS en Android APP",
      "TIME_LINE_6": "Pinploy absorbeert Handyhand, het grootste klusjesplatform in Denemarken, en neemt ook de naam Handyhand aan",
      "TIME_LINE_DATE_6": "Augustus, 2022",
      "TIME_LINE_TITLE_6": "Pinploy wordt Handyhand",
      "TIME_LINE_7": "Handyhand passeert 50.000 geregistreerde gebruikers op het platform",
      "TIME_LINE_DATE_7": "September, 2019",
      "TIME_LINE_8": "Handyhand bereikt 100.000 gebruikers — een grote mijlpaal voor het platform",
      "TIME_LINE_DATE_8": "Juli, 2022",
      "TIME_LINE_9": "Handyhand passeert 150.000 gebruikers en is nu voor iedereen beschikbaar in heel Denemarken",
      "TIME_LINE_DATE_9": "Augustus, 2023",
      "TIME_LINE_10": "Een erkend Deens platform voor schoonmaakservices dat klanten verbindt met betrouwbare, zelfstandige schoonmakers. Overgenomen in april 2024 om beide platforms te versterken, met behoud van hun eigen identiteit.",
      "TIME_LINE_DATE_10": "April, 2024",
      "TIME_LINE_TITLE_10": "Happy Helper overgenomen",
      "TIME_LINE_11": "Handyhand passeert 200.000 gebruikers op het hele platform",
      "TIME_LINE_DATE_11": "Mei, 2024",
      "TIME_LINE_12": "Handyhand passeert 300.000 gebruikers en zet zijn sterke groei voort",
      "TIME_LINE_DATE_12": "Juni, 2025",
      "TIME_LINE_13": "Een platform dat in november 2025 is overgenomen en Saxo Agdesteins portfolio binnen marktplaatsen en dienstverlenende bedrijven uitbreidt.",
      "TIME_LINE_DATE_13": "November, 2025",
      "TIME_LINE_TITLE_13": "Shouter overgenomen",
      "TIME_LINE_14": "Handyhand passeert een half miljoen gebruikers — een historische mijlpaal voor het platform",
      "TIME_LINE_DATE_14": "Januari, 2026",
      "TIME_LINE_SUBTITLE_REBRAND": "Rebrand",
      "TIME_LINE_SUBTITLE_APP": "App",
      "TIME_LINE_CARD_TITLE_APP": "iOS en Android",
      "TIME_LINE_MILESTONE_500K_PLUS": "500K+",
      "TIME_LINE_MILESTONE_300K": "300K",
      "TIME_LINE_MILESTONE_200K": "200K",
      "TIME_LINE_MILESTONE_150K": "150K",
      "TIME_LINE_MILESTONE_100K": "100K",
      "TIME_LINE_MILESTONE_50K": "50K",
      "TIME_LINE_LOGO_ALT_SUFFIX": "logo",
      "MEDIA_TITLE": "Handyhand in de media",
      "MEET_TEAM_TITLE": "Ontmoet het team",
      "MEET_TITLE": "Ontmoet het team",
      "META_TITLE": "Over het team achter Handyhand",
      "META_DESC": "Wie zijn wij en waarom zijn we Handyhand gestart? Krijg hier antwoord",
      "STAT_MEMBERS": "leden",
      "STAT_PROVIDERS": "aanbieders",
      "STAT_REVIEWS": "beoordelingen",
      "HOW_IT_WORKS_TITLE": "Zo werkt het",
      "HOW_STEP_1_TITLE": "Maak een klus aan",
      "HOW_STEP_1_DESC": "Beschrijf je klus en ontvang offertes van gekwalificeerde helpers in je buurt.",
      "HOW_STEP_2_TITLE": "Kies je helper",
      "HOW_STEP_2_DESC": "Vergelijk offertes, lees beoordelingen en kies de helper die het beste bij de klus past.",
      "HOW_STEP_3_TITLE": "De klus wordt uitgevoerd",
      "HOW_STEP_3_DESC": "Je helper voert de klus uit. Betaal veilig via het platform wanneer je tevreden bent.",
      "MISSION_TITLE": "Onze waarden",
      "VALUE_1_TITLE": "Veiligheid",
      "VALUE_1_DESC": "Alle gebruikers worden geverifieerd. Wij zorgen voor een veilige omgeving voor zowel opdrachtgevers als helpers.",
      "VALUE_2_TITLE": "Gemeenschap",
      "VALUE_2_DESC": "We verbinden mensen in de lokale gemeenschap en creëren kansen voor iedereen.",
      "VALUE_3_TITLE": "Eerlijke betaling",
      "VALUE_3_DESC": "Helpers bepalen zelf hun prijs. Geen verborgen kosten, transparante voorwaarden.",
      "VALUE_4_TITLE": "Voor iedereen",
      "VALUE_4_DESC": "Of je nu je heg wilt laten knippen of een kast wilt laten monteren — bij ons is er plek voor alle klussen.",
      "WHY_TITLE": "Waarom Handyhand?",
      "WHY_1": "Het grootste platform voor dagelijkse hulp met meer dan {{users}} leden",
      "WHY_2": "Alle helpers en opdrachtgevers worden geverifieerd voor jouw veiligheid",
      "WHY_3": "Veilige betaling via het platform — je betaalt pas als de klus is uitgevoerd",
      "WHY_4": "Gratis om klussen aan te maken — je betaalt alleen wanneer je een offerte accepteert",
      "WHY_5": "Meer dan 20.000 beoordelingen op Trustpilot met een gemiddelde van 4,5 sterren",
      "GROWTH_TITLE": "Onze impact",
      "GROWTH_TASKS": "aangemaakte klussen",
      "GROWTH_PAID": "uitbetaald aan helpers",
      "GROWTH_PAID_VALUE": "200M+ €",
      "GROWTH_COVERAGE_VALUE": "Heel NL",
      "GROWTH_COVERAGE": "landelijk",
      "TRUSTPILOT_DESC": "Gebaseerd op meer dan 5.000 beoordelingen op Trustpilot",
      "PARTNERS_TITLE": "Vertrouwde partners",
      "MASCOT_TITLE": "Ontmoet Kuno - De mascotte van Handyhand",
      "MASCOT_VIDEO_1_TITLE": "Nieuwe lamp - Handyhand",
      "MASCOT_VIDEO_2_TITLE": "Hallo buur - Handyhand",
      "MASCOT_VIDEO_3_TITLE": "Verhuisdag - Handyhand"
    },
    "APP_LANDING": {
      "META_TITLE": "Handyhand App voor iOS en Android - Download",
      "META_DESC": "Verdien geld door klussen in huis uit te voeren met de app op ons platform - Deel klussen die je uitgevoerd wilt hebben, bied op klussen en blijf op de hoogte van je klussen rechtstreeks op je telefoon",
      "TITLE": "Mis nooit",
      "TITLE_1": "meer",
      "TITLE_2": "iets",
      "UPDATE_CONTENT": "Maak klussen aan die je uitgevoerd wilt hebben, doe biedingen en blijf op de hoogte, zelfs onderweg.",
      "ON_THE_GO": "Leer de app kennen",
      "POST_BROWSE_TASKS_HEADLINE": "Maak aan of vind klussen",
      "POST_BROWSE_TASKS_CONTENT": "Maak klussen aan waarvoor je hulp wilt, of bied op klussen die je wilt uitvoeren.",
      "COMMUNICATION_HEADLINE": "Makkelijk communiceren met anderen",
      "COMMUNICATION_CONTENT": "Wanneer je een bod accepteert van een Handyhand, of zelf bent gekozen om een klus uit te voeren, is het mogelijk om direct te communiceren via privéberichten.",
      "PAYMENTS_HEADLINE": "Snelle en veilige betaling",
      "PAYMENTS_CONTENT": "Via ons veilige betalingssysteem word jij of je Handyhand betaald voor het uitgevoerde werk.",
      "DOWNLOAD_NOW": "Download de app nu",
      "MOCKUPS": {
        "TASK_NEW": {
          "HEADER": "Nieuwe klus",
          "HERO_SUB": "Vandaag is een goede dag om klussen te laten doen!",
          "HERO_TITLE": "Welke klus moet er gedaan worden?",
          "QUESTION_WHAT": "Waar heb je hulp bij nodig?",
          "EXAMPLE_INPUT": "bijv. een kamer schilderen",
          "QUESTION_WHEN": "Wanneer moet het gedaan worden?",
          "PILL_SPECIFIC_DATE": "Specifieke datum",
          "PILL_BEFORE_DATE": "Vóór datum",
          "PILL_FLEXIBLE": "Flexibel",
          "TOGGLE_TIMESLOT": "Er is een specifiek tijdvak nodig",
          "NEXT_BUTTON": "Volgende"
        },
        "TASK_INPUT": {
          "QUESTION_WHAT": "Waar heb je hulp bij nodig?",
          "EXAMPLE_INPUT": "Hulp bij het verplaatsen van een bank",
          "QUESTION_WHEN": "Wanneer?",
          "PILL_ON_DATE": "Op datum",
          "PILL_BEFORE_DATE": "Vóór datum",
          "PILL_FLEXIBLE": "Flexibel"
        },
        "CHAT": {
          "NAME_1": "Lars",
          "NAME_2": "Jens",
          "INITIAL_1": "L",
          "INITIAL_2": "J",
          "MSG_1": "Hoi Lars, we hebben de doorgang vrijgemaakt zodat jullie de bank via de voordeur kunnen binnendragen – dat moet het iets makkelijker maken",
          "MSG_2": "Hoi Jens, top, dat helpt zeker. We zijn er om 8.30 uur!"
        },
        "PAYMENT": {
          "HEADER": "Betaling",
          "STATUS": "Betaling verzonden",
          "AMOUNT": "€ 50",
          "LABEL": "Aan de Handyhand",
          "RECEIPT_DATE": "Vandaag · 09:41"
        }
      }
    },
    "BLOG": {
      "TITLE": "Handyhand Artikelen",
      "DESC": "Artikelen, tips en trucs voor huis, tuin en doe-het-zelf."
    },
    "CREATE_TASK": {
      "STEPS_BUDGET_GENERATOR": {
        "TITLE": "Budgetschatting",
        "ELAB_QUESTIONS": "Aanvullende vragen",
        "SUB_V1": "Gebaseerd op meer dan {{tasks}} klussen hebben we een schatting gemaakt voor je project. Ontvang verschillende offertes en kies de beste. De uiteindelijke prijs wordt pas vastgesteld wanneer je een offerte kiest.",
        "FAILED": "We konden je budget niet berekenen. Probeer een meer gedetailleerde klusbeschrijving in te voeren of kies zelf een budget en bekijk eventueel vergelijkbare klussen.",
        "CALCULATING_BUDGET": "Budget berekenen",
        "CALCULATING_BUDGET_DESCRIPTION": "Er wordt een budgetschatting berekend voor de klus op basis van meer dan {{tasks}} andere klussen - even geduld...",
        "LOW": "Laag",
        "AVG": "Gemiddeld",
        "HIGH": "Hoog",
        "AI_WELCOME": "Hallo, ik ben Handyhands AI-budgetschattingstool!.",
        "DESC": "Beschrijving",
        "BUDGET": "Budget",
        "SUB_TASKS": "Deeltaken",
        "EXPLAIN": "Uitleg",
        "YOUR_ESTIMATE": "Jouw budgetschatting",
        "YOUR_ESTIMATE_DESC": "Je kunt zelf een budget invoeren als je het niet eens bent met de schatting.",
        "FAILED_PREDICT": "Kon geen budget schatten op basis van de klusbeschrijving. Voer alsjeblieft handmatig een budget in.",
        "FINISHING_UP": "Bezig, even geduld, dit kan tot 30 seconden duren",
        "CREATE_TASK": "Maak klus aan",
        "CREATE_TASK_TIP": "*Je kunt de details bewerken nadat je op 'Maak klus aan' hebt geklikt",
        "LOADING_STEPS": {
          "LOADING": {
            "ANALYZING_TASK_TYPE": "Type klus analyseren...",
            "ESTIMATING_TASK_SCOPE": "Omvang van de klus schatten...",
            "COMPARING_TASKS": "Vergelijken met {{tasks}}+ klussen...",
            "FINDING_PRICES_RUNNING_TASKS": "Prijzen van vergelijkbare klussen zoeken...",
            "ESTIMATING_BUDGET_TASK": "Budget voor je klus schatten..."
          },
          "COMPLETED": {
            "ANALYZING_TASK_TYPE": "Klus is geanalyseerd",
            "ESTIMATING_TASK_SCOPE": "Omvang van de klus is geschat",
            "COMPARING_TASKS": "{{tasks}}+ klussen vergeleken",
            "FINDING_PRICES_RUNNING_TASKS": "Prijzen van vergelijkbare klussen gevonden",
            "ESTIMATING_BUDGET_TASK": "Budgetschatting berekend"
          }
        },
        "CERTAINTY_SCORE": {
          "TITLE": "Nauwkeurigheid van het budget",
          "LOW": "LAAG",
          "MEDIUM": "GEMIDDELD",
          "HIGH": "HOOG"
        },
        "FAQ": "Vragen en antwoorden",
        "FAQ_1": "Hoe werkt de budgetcalculator?",
        "FAQ_1_1": "We gebruiken kunstmatige intelligentie om nauwkeurig een budget voor je project te schatten. Door je project te vergelijken met meer dan {{tasks}} vergelijkbare klussen, gebruiken onze geavanceerde algoritmes data om prijzen vast te stellen. We houden rekening met de omvang van het project om een op maat gemaakt budget te maken op basis van deze informatie.",
        "FAQ_2": "Hoe is mijn budget berekend?",
        "FAQ_2_1": "[VOEG HIER BUDGETBEREKENINGS UITLEG TOE]",
        "FAQ_3": "Waarom moet mijn klus een budget hebben?",
        "FAQ_3_1": "Een budget helpt Handyhanders te begrijpen wat je verwacht te betalen voor de klus. Het helpt ook om ervoor te zorgen dat je realistische offertes krijgt op de klus.",
        "FAQ_4": "Wat als ik het niet eens ben met het budget?",
        "FAQ_4_1": "Je kunt altijd het budget wijzigen als je het er niet mee eens bent. Je kunt ook kiezen om je eigen budget in te voeren.",
        "FAQ_SIMILAR_1": "Vergelijkbare klussen die anderen hebben laten uitvoeren ",
        "FAQ_SIMILAR_2": "en",
        "FAQ_SIMILAR_3": "Bekijk enkele voorbeelden van echte klussen die anderen op het platform hebben aangemaakt en welke offertes ze hebben ontvangen",
        "SIMILAR_TASKS": {
          "DESC": "Beschrijving",
          "PRICE": "Gemiddelde offerte op de klus",
          "PRICE_TOOLTIP": "Het gemiddelde van alle offertes op de klus",
          "TIME": "Geschatte tijd voor de klus",
          "TASK_OWNER": "Aangemaakt door",
          "HOURS": "uren",
          "HOUR": "uur",
          "NUMBER_OF_OFFERS": "Offertes op de klus",
          "MATCH_DEGREE": "Matchpercentage",
          "MATCH_TOOLTIP": "Hoe goed je klus overeenkomt met deze klus"
        }
      }
    },
    "HH_LANDING": {
      "BASED_ON": "Gebaseerd op",
      "BECOME": "Word Handyhander",
      "JOB_CATEGORIES_TITLE": "Vind klussen per categorie",
      "JOB_CATEGORIES_DESC": "Bekijk de soorten klussen waar het vaakst werk is, en begin daar waar jouw vaardigheden het best passen.",
      "EARN": "Verdien geld",
      "HEADER_TITLE": "Word je eigen baas",
      "HEADER_TITLE_1": "Verdien tot €3.500 per maand op Handyhand",
      "HEADER_DESC": "Hoe kun je snel wat extra geld verdienen? Het antwoord is Handyhand.nl. Wil je werk vinden en online geld verdienen, dan is Handyhand de juiste plek voor jou. Met ons online platform kun je snel klussen vinden die bij je passen.",
      "HEADER_CTA_TEXT": "Aanmaken, kiezen, klaar.",
      "HEADER_CTA_PRIMARY_BUTTON": "Begin nu",
      "HEADER_CTA_SECONDARY_BUTTON": "Bekijk klussen",
      "HOW_IT_WORKS_FIND_TITLE": "Vind een klus",
      "HOW_IT_WORKS_FIND_DESC": "Vind een klus die je wilt uitvoeren en doe een bod",
      "HOW_IT_WORKS_CREATE_TITLE": "Maak je profiel aan",
      "HOW_IT_WORKS_CREATE_DESC": "Maak gratis een profiel aan op Handyhand",
      "HOW_IT_WORKS_DO_TITLE": "Voer de klus uit en word betaald",
      "HOW_IT_WORKS_DO_DESC": "Voer de klus uit en ontvang betaling en een beoordeling",
      "FEATURE_SECTION_TITLE": "Waarom zou ik Handyhand gebruiken?",
      "FEAT_1": "Veilige betaling",
      "FEAT_2": "HandyhandPay zorgt ervoor dat je altijd voor je werk wordt betaald, zonder risico op oplichting en zonder dat je zelf achter je geld aan hoeft.",
      "FEAT_3": "Verbeter je reputatie",
      "FEAT_4": "Met Handyhand krijg je een profiel waar je badges, sterren, beoordelingen en meer kunt verdienen, die je kunt tonen of linken.",
      "FEAT_5": "Makkelijk en snel",
      "FEAT_6": "Je kunt snel en eenvoudig werk vinden in je buurt. Het Handyhand platform geeft een makkelijk en snel overzicht van beschikbare klussen bij jou in de buurt.",
      "META_TITLE": "Word Handyhand | Vind klussen | Bijbanen | Werk | Parttime werk | Handyhand™",
      "META_DESC": "✅Verdien geld met Handyhand. ✅ Nederlands beste marktplaats voor klussen. ✅ Van klusjesman tot schoonmaak. ✅ Vind nu werk en verdien online geld.",
      "PLATFORM_RIGHT_TITLE": "Vind gratis werkmogelijkheden",
      "PLATFORM_RIGHT_DESC": "Word Handyhander en begin direct met geld verdienen. Ontvang meldingen in onze app telkens wanneer er een klus is die past bij je vaardigheden en interesses.",
      "PLATFORM_TASK_TITLE": "Bepaal je prijs",
      "PLATFORM_TASK_DESC": "Heb je een klus gevonden die bij je past? Bepaal je prijs en stuur een offerte. Je kunt de offerte later aanpassen en bespreken met de klant.",
      "PLATFORM_COMM_TITLE": "Voer de klus uit en ontvang de betaling. Zo simpel is het",
      "PLATFORM_COMM_DESC": "Wanneer je aangeeft dat een klus is voltooid, wordt er automatisch een betalingsverzoek verzonden en zodra de klusgever deze goedkeurt, wordt het geld vrijgegeven in het systeem.",
      "TESTOMONIALS_TITLE": "Andere Handyhanders",
      "WHY_HANDYHAND_TITLE": "Maak vandaag je profiel aan en vind klussen",
      "WHY_HANDYHAND_DESC1": "Het duurt slechts enkele minuten om een profiel aan te maken en dan kun je beginnen met het vinden van je eerste klus",
      "WHY_HH_TITLE": "Verdien extra geld met Handyhand",
      "WHY_HH_DESC1": "Verdien snel en makkelijk met Handyhand.nl! Of je nu klusjesman, vakman, bijlesdocent of schoonmaakhulp bent, vind flexibele klussen die bij je passen.",
      "WHY_HH_DESC2": "Ons platform verbindt je met klussen - sommige Handyhanders verdienen meer dan €3.500 per maand!",
      "WHY_HH_DESC3": "Het platform is perfect voor zowel professionals, studenten als gepensioneerden die extra inkomsten zoeken. Neem controle over je tijd en inkomsten met Handyhand!",
      "WHY_HH_CTA_TEXT": "Klaar om deel uit te maken van de gemeenschap?",
      "WHY_HH_BUTTON": "Word Handyhander",
      "USP_1": "Verdien tot €3.500 per maand",
      "USP_2": "Snel aan de slag - verdien geld vanaf de eerste dag",
      "USP_3": "Automatische schadevergoeding die zowel jou als de klant beschermt",
      "USP_4": "Gebruik onze app om alles te beheren",
      "USP_5": "Jij bepaalt welke klussen je aanneemt - en hoe vaak",
      "QUESTION_1": "Klaar om je eigen baas te zijn?",
      "QUESTION_2": "Ben je een klusjesman, schoonmaakexpert of kun je een heel andere dienst aanbieden, Handyhand is een platform voor  deeleconomie waar je lokaal klussen kunt plaatsen of werk kunt vinden.<br/><br/>  Handyhand maakt het makkelijk om kleine of middelgrote klussen online te vinden via ons platform. Help mensen met het oplossen van klussen in huis en verdien vandaag nog geld met kleine klussen."
    },
    "HOW_IT_WORKS": {
      "HERO": {
        "REVIEWS": "Beoordelingen",
        "TASK_COMPLETED": "Klus afgerond",
        "TASK_PAID": "Betaling verzonden",
        "TIME_2_MIN_AGO": "2 min geleden",
        "TIME_1_MIN_AGO": "1 min geleden"
      },
      "MOCKUPS": {
        "TITLE_DUEDATE": {
          "QUESTION_WHAT": "Wat moet er gedaan worden?",
          "EXAMPLE_INPUT": "Hulp bij het verplaatsen van een bank",
          "QUESTION_WHEN": "Wanneer?",
          "PILL_ON_DATE": "Op datum",
          "PILL_BEFORE_DATE": "Voor datum",
          "PILL_FLEXIBLE": "Flexibel"
        },
        "LOCATION": {
          "QUESTION_WHERE": "Waar is de klus?",
          "OPTION_IN_PERSON": "Vereist aanwezigheid",
          "OPTION_ONLINE": "Online"
        },
        "DESCRIPTION": {
          "TITLE": "Omschrijving",
          "EXAMPLE_TEXT": "Ik heb een nieuwe bank gekocht die aan de stoep wordt geleverd, maar ik heb hulp nodig om hem naar de 3e verdieping te dragen",
          "ADD_IMAGES_LABEL": "Foto's toevoegen"
        },
        "BUDGET": {
          "QUESTION_BUDGET": "Wat is je budget?",
          "EXAMPLE_AMOUNT": "€ 50"
        },
        "GET_OFFERS": {
          "NEW_OFFERS_BADGE": "5 nieuwe biedingen ontvangen",
          "ACCEPT": "Accepteren",
          "NAME_1": "Maria",
          "NAME_2": "Jeroen",
          "NAME_3": "Floris",
          "NAME_4": "Sander"
        }
      },
      "TITLE": "Maak je klus aan in enkele minuten",
      "CREATE_TASK": " Maak je klus aan, kies een persoon, en je bent klaar",
      "COMMUNICATION_TITLE_1": "Makkelijk communiceren",
      "COMMUNICATION_CONTENT_1": "Wanneer je een bod hebt geaccepteerd, kun je direct contact opnemen met je Handyhand via privéberichten. Samen kunnen jullie de details bespreken en contact houden totdat de klus is opgelost.",
      "CLOSE": "Sluiten",
      "STEPS": {
        "TITLE_DUEDATE_STEP_TITLE": "Geef aan wat je uitgevoerd wilt hebben en wanneer",
        "TITLE_DUEDATE_STEP_DESC": "Beschrijf kort wat je uitgevoerd wilt hebben en geef aan wanneer je de klus uitgevoerd wilt hebben",
        "LOCATION_STEP_TITLE": "Waar moet de klus worden uitgevoerd?",
        "LOCATION_STEP_DESC": "Geef aan waar de klus moet worden uitgevoerd. Is het bijvoorbeeld iets waarvoor de Handyhander persoonlijk aanwezig moet zijn of kan het online via videobellen worden opgelost?",
        "DESCRIPTION_STEP_TITLE": "Beschrijf in het kort waar de klus over gaat",
        "DESCRIPTION_STEP_DESC": "De beschrijving helpt onze Handyhanders de klus te beoordelen, zodat je de best mogelijke offerte krijgt.",
        "BUDGET_STEP_TITLE": "Kies je budget",
        "BUDGET_STEP_DESC": "Dit is slechts een schatting - de uiteindelijke prijs kun je later onderhandelen.",
        "GET_OFFERS_STEP_TITLE": "Ontvang offertes en kies de beste voor de klus",
        "GET_OFFERS_STEP_DESC": "Bekijk profielen en beoordelingen en beoordeel zelf wie het beste past bij de klus."
      },
      "DESC_CONTENT_1": "Met honderden klussen op het platform elke maand, is er genoeg mogelijkheid om klussen uit te voeren en geld te verdienen. Kies de klussen die het beste bij jou en je vaardigheden passen.",
      "DESC_CONTENT_2": "Met Handyhands veilige betalingssysteem kun je erop vertrouwen dat je je betaling ontvangt wanneer de klus is voltooid.",
      "DESC_SUBTITLE_3": "Uitgebreide schadevergoeding",
      "DESC_CONTENT_3": "Met behulp van ons schadevergoedingsmodel kun je veilig klussen uitvoeren via Handyhand. Lees meer over de schadevergoeding ",
      "HEADLINE": "Zo werkt het",
      "LIGHTBOX_BUTTON": "Video-introductie",
      "META_TITLE": "Hoe het werkt",
      "META_DESC": "Krijg toegang tot duizenden bekwame mensen voor klussen in alle categorieën, van meubelmontage tot gegevensbeheer. Huur vandaag nog een bekwame Handyhander in.",
      "PAY_TITLE": "HandyhandPay",
      "PAY_CONTENT_1": "Met HandyhandPay kun je makkelijk en veilig je Handyhand betalen wanneer je een klus laat oplossen via Handyhand. Ons betalingssysteem houdt het bedrag vast totdat de klus is voltooid.",
      "PAY_CONTENT_2": "Pas wanneer de klus als voltooid is gemeld, wordt het geld uitbetaald aan je Handyhand. Mocht de klus niet worden uitgevoerd, dan wordt het geld natuurlijk teruggestort op je rekening.",
      "PAY_ICON_1": "Snel en veilig",
      "PAY_ICON_2": "Contantloos",
      "PAY_ICON_3": "Jij hebt de controle",
      "SUB_HEADER_1": "Wat moet er uitgevoerd worden?",
      "SUB_HEADER_2": "Kies de juiste Handyhander voor de klus",
      "SUB_HEADER_3": "Voltooide klus",
      "SUB_TEXT_1": "Begin met ons te vertellen over je klus. Beschrijf wanneer en waar het uitgevoerd moet worden, en stel vervolgens een redelijk budget voor de klus in. Je kunt elk type klus delen, van schoonmaak tot webdesign, in slechts twee minuten. Het is 100% vrijblijvend en gratis om te beginnen.",
      "SUB_TEXT_2": "Bekijk profielen en beoordelingen om de beste Handyhand voor je klus te kiezen. Wanneer je een bod accepteert, wordt je betaling veilig gehouden met HandyhandPay totdat de klus is voltooid en je tevreden bent. Nu kun je berichten sturen en bellen met je Handyhand om de details te regelen.",
      "SUB_TEXT_3": "Wanneer je klus is voltooid, geef je simpelweg de betaling vrij die wordt ingehouden met HandyhandPay. Nu kun je een beoordeling schrijven over het werk van de Handyhand, zodat iedereen het goede werk kan zien dat hij/zij heeft gedaan!",
      "SUB_HEAD_TEXT": "Bespaar jezelf gedoe en werk je to-do lijst vandaag nog af ",
      "HEADER": "Alle dagelijkse klussen op één platform",
      "HH_DESC": "Verdien geld met Handyhand",
      "HH_BOSS": "Wees je eigen baas",
      "HERE": "hier.",
      "SAFE_PAY": "Veilige betaling",
      "DOWNLOAD_APP_TITLE": "Blijf op de hoogte",
      "DOWNLOAD_APP_CONTENT_1": "Met de Handyhand app kun je altijd op de hoogte blijven, zelfs onderweg. Je kunt klussen aanmaken, offertes bekijken of communiceren met je Handyhand. Je kunt ook bieden op klussen van anderen en in de gaten houden of je biedingen worden geaccepteerd.",
      "REVIEWS_TITLE": "Beoordelingen & recensies",
      "REVIEWS_CONTENT_1": "Het platform biedt de mogelijkheid om profielen te bekijken en recensies te lezen van onze Handyhanders. Op deze manier krijg je de beste basis om de juiste persoon voor de klus te kiezen.",
      "STEP_1": "Beschrijf je klus",
      "STEP_2": "Ontvang offertes",
      "STEP_3": "Laat je klus uitvoeren",
      "TASKS": {
        "FURNITURE_ASSEMBLY": {
          "TITLE": "Meubelmontage",
          "DESCRIPTION": "IKEA kast monteren"
        },
        "PAINTING": {
          "TITLE": "Schilder",
          "DESCRIPTION": "Schilderen voor verhuizing"
        },
        "MOVING_ASSISTANCE": {
          "TITLE": "Verhuishulp",
          "DESCRIPTION": "Verhuizen naar Rotterdam"
        },
        "GARDENING": {
          "TITLE": "Tuinwerk",
          "DESCRIPTION": "Vier bomen snoeien"
        },
        "IT_SUPPORT": {
          "TITLE": "IT ondersteuning",
          "DESCRIPTION": "Windows installatie"
        },
        "ELECTRICIAN": {
          "TITLE": "Elektricien",
          "DESCRIPTION": "Sonos installeren"
        },
        "CLEANING": {
          "TITLE": "Schoonmaak",
          "DESCRIPTION": "Wekelijkse schoonmaak"
        },
        "MOVING_ASSISTANCE_2": {
          "TITLE": "Verhuishulp",
          "DESCRIPTION": "Inboedel verhuizen"
        },
        "ELECTRICIAN_2": {
          "TITLE": "Elektricien",
          "DESCRIPTION": "Lampen ophangen"
        },
        "CATERING": {
          "TITLE": "Catering",
          "DESCRIPTION": "Diner voor 14"
        },
        "PLUMBING": {
          "TITLE": "Loodgieter",
          "DESCRIPTION": "Wastafel repareren"
        },
        "CARPENTRY": {
          "TITLE": "Timmerwerk",
          "DESCRIPTION": "Boekenkast bouwen"
        },
        "DOG_WALKING": {
          "TITLE": "Hond uitlaten",
          "DESCRIPTION": "Dagelijkse wandelingen"
        },
        "PHOTOGRAPHY": {
          "TITLE": "Fotografie",
          "DESCRIPTION": "Familiefotoshoot"
        },
        "WEB_DESIGN": {
          "TITLE": "Webdesign",
          "DESCRIPTION": "Website maken"
        },
        "TUTORING": {
          "TITLE": "Bijles",
          "DESCRIPTION": "Wiskundehulp"
        },
        "WINDOW_CLEANING": {
          "TITLE": "Ramen lappen",
          "DESCRIPTION": "Ramen schoonmaken"
        },
        "LAWN_MOWING": {
          "TITLE": "Gras maaien",
          "DESCRIPTION": "Gazon maaien"
        },
        "GRAPHIC_DESIGN": {
          "TITLE": "Grafisch ontwerp",
          "DESCRIPTION": "Logo ontwerpen"
        },
        "HANDYMAN": {
          "TITLE": "Klusjesman",
          "DESCRIPTION": "Kleine reparaties"
        }
      }
    },
    "LANDING": {
      "COMMUNITY_1": "Handyhand is een marktplaats",
      "COMMUNITY_2": "Met {{handyhanders}}+ geverifieerde en beoordeelde bedrijven en particulieren die hulp bieden bij klussen van elke soort.",
      "EARN": "Verdien geld met Handyhand",
      "FOOTER_DESC": "Handyhand is een Nederlandse marktplaats netwerk waar mensen hulp kunnen vinden voor klussen van elke soort, in contact kunnen komen met particuliere klussers en lokale diensten, of flexibele klussen kunnen uitvoeren en geld verdienen.",
      "FOOTER_SLOGAN": "Wij focussen op veiligheid, vertrouwen en transparantie.",
      "FOOTER_COMPANY": "Bedrijf",
      "FOOTER_EXPLORE": "Ontdek",
      "HERO_USP_1": "klanten",
      "HERO_USP_2": "klussen",
      "HERO_USP_3": "beoordelingen",
      "LANG_SWITCH": "Verander taal naar ",
      "MEET": "Ontmoet enkele Handyhanders",
      "META_TITLE": "Laat klussen in huis uitvoeren of verdien geld op Handyhand",
      "META_DESC": "Laat klussen uitvoeren in schoonmaak, ophalen, timmerwerk, muurmontage voor thuis. Handyhand is een online platform voor kleine klussen, maak een klus aan en ontvang vandaag nog offertes van Handhyhanders.",
      "OWN_BOSS": "Je eigen baas",
      "OWN_BOSS_DESC": "Ben je handig met je handen, of misschien een tovenaar in IT? Misschien wacht je volgende klus op Handyhand.",
      "OWN_BOSS_USP_1": "Gratis toegang tot duizenden klussen",
      "OWN_BOSS_USP_2": "Geen abonnement of verborgen kosten",
      "OWN_BOSS_USP_3": "Verdien extra wanneer je tijd en zin hebt",
      "SUB_TXT": "Verhuizen, tuinwerk, loodgieter, klusjesman en",
      "SUB_TXT_2": "nog veel meer.",
      "USP_MAIN_TITLE": "Waarom zou ik Handyhand gebruiken?",
      "USP_HERO_WOMAN_ALT": "Vrouw met telefoon",
      "USP_HERO_WOMAN_IMG_PATH": "private/lp/webp/happy_woman_with_phone_nl.webp",
      "USP_1_DESC": "Betaal pas uit wanneer de klus naar tevredenheid is voltooid",
      "USP_2_DESC": "Kies de juiste Handyhander voor de klus op basis van geverifieerde beoordelingen en ratings",
      "USP_3_DESC": "Gedekt door onze uitgebreide schadevergoeding, mocht er een ongeluk gebeuren. Lees meer over",
      "USP_3_LINK": "Schadevergoeding.",
      "USP_1_TITLE": "Veilige betaling",
      "USP_2_TITLE": "Geverifieerde beoordelingen",
      "USP_3_TITLE": "Schadevergoeding",
      "USP_EASY": "Makkelijk te gebruiken",
      "OR_ANYTHING": "... of iets heel anders?",
      "USP_JOB": " Je kunt direct beginnen met zoeken naar klussen bij jou in de buurt. Je\n kunt filteren op locatie en categorieën en meldingen krijgen wanneer er\n                klussen verschijnen waarin je geïnteresseerd bent bij jou in de buurt.",
      "WHY_PAY_TIT": "Snelle en veilige betaling",
      "WHY_PAY_DESC": "We beveiligen je betaling al voordat je de klus start, zodat je\n zeker weet dat het geld er is wanneer de klus is voltooid.",
      "HH_PROFILE_IMG_ALT": "Handyhand profielfoto",
      "HH_NAME_1": "Bram",
      "HH_NAME_2": "Sanne",
      "HH_NAME_3": "Jeroen",
      "HH_DESC_1": "Bram heeft 10 jaar ervaring als klusjesman en biedt nu ook tips om je huis te optimaliseren aan, zoals op maat gemaakte planken en slimme oplossingen die je huis een persoonlijke touch geven.",
      "HH_DESC_2": "Sanne heeft 7 jaar ervaring met schoonmaken en helpt ook met organiseren – van kasten en laden tot kinderkamers, altijd met structuur en overzicht.",
      "HH_DESC_3": "Jeroen is tuinexpert en transformeert tuinen met landschapsontwerp, prachtige bloembedden en decoratieve paden tot gezellige zithoekjes.",
      "HH_TRUST": "Vertrouwen",
      "HH_WHAT_OTHERS_SAY": "Wat anderen zeggen over ",
      "HH_WHAT_OTHERS_SAY_1": "Zeer vriendelijk en betrouwbaar. Kan Bram zeker aanbevelen voor klusjes in en rond het huis. Bedankt voor de hulp!",
      "HH_WHAT_OTHERS_SAY_2": "Sanne redde me van de chaos toen de kinderen alles hadden omgegooid – ze ruimde op met een glimlach en de kinderen waren dol op haar.",
      "HH_WHAT_OTHERS_SAY_3": " Deed prachtig werk in de tuin en heeft een geweldig positieve uitstraling. We zullen Jeroen zeker weer gebruiken in de tuin.",
      "HH_TESTIMONIAL_1": "Zeer vriendelijk en betrouwbaar. Kan Bram zeker aanbevelen voor klusjes in en rond het huis. Bedankt voor de hulp!",
      "HH_TESTIMONIAL_2": "Amanda bracht orde in ons huis en was zorgzaam en kwam op tijd. We zullen Amanda zeker nog een keer inhuren..",
      "HH_TESTIMONIAL_3": " Deed prachtig werk in de tuin en heeft een geweldig positieve uitstraling. We zullen Jeroen zeker weer gebruiken in de tuin.",
      "HH_SPECIALITY_1": "Klusjesman, meubelmontage, verhuishulp",
      "HH_SPECIALITY_2": "Schoonmaak, verhuishulp, meubelmontage",
      "HH_SPECIALITY_3": "Tuinwerk, schilder, hondenuitlater",
      "HOW_1": "Hoe werkt het?",
      "HOW_2": "Wat moet er uitgevoerd worden?",
      "HOW_2_1": "Hier vind je zowel professionele vakmensen als bekwame Handyhanders, klaar om je klus op te lossen.",
      "HOW_2_2": "Bekijk alle categorieën",
      "HOW_4": "Offertes bekijken",
      "HOW_5": "Ontvang offertes van bekwame mensen en bekijk hun profielen",
      "HOW_6": "Laat het uitvoeren",
      "HOW_7": "Kies de juiste voor je klus en laat het uitvoeren",
      "HOW_8": "Deel je klus",
      "HOW_9": "Maak je klus aan en beschrijf deze. Het is gratis om aan te maken",
      "HOW_10": "De onderstaande video laat zien hoe Handyhand je kan helpen met het oplossen van je dagelijkse klussen.",
      "HOW_DESC": "Beschrijf je klus en laat hem online oplossen, alles voor thuis",
      "HOW_ONLINE": "Maak een klus aan en ontvang verschillende offertes online",
      "POPULAR_CATEGORIES": "Populaire categorieën",
      "PRICE_INDEX": "Prijsgegevens",
      "PRICE_GUIDES": "Prijsgidsen",
      "SEE_VID": "Bekijk hoe",
      "HERO_IMG_ALT": "Marktplaats voor klussen in huis",
      "PAUSE_ROTATION": "Rotatie pauzeren",
      "RESUME_ROTATION": "Rotatie hervatten",
      "STARS": "Sterren",
      "TO_BUTTON": "Maak gratis een klus aan",
      "PP_BUTTON": "Verdien vandaag geld",
      "COPYRIGHT": "Copyright Pinploy ApS. - 2026",
      "FAQ": {
        "FAQ_HEADER": "Vragen en antwoorden",
        "FAQ_1_QUESTION": "Wat kost het om Handyhand te gebruiken?",
        "FAQ_1_ANSWER": "Handyhand is een gratis platform om hulp te vinden voor je klussen. Het enige wat je betaalt is de hulp die je vindt via het platform, die vaak tot 70% voordeliger is dan de vakmanprijs. Je ontvangt offertes van zowel particulieren als bedrijven. Als je niet weet wat je moet betalen voor een klus, kun je de optie 'Ontvang offertes' kiezen, en onze Handyhanders geven hun bod op wat de klus moet kosten. Het enige wat je hoeft te doen is je klus aanmaken, offertes ontvangen en je Handyhander kiezen. Je Handyhander wordt pas via ons systeem betaald wanneer de klus is voltooid.",
        "FAQ_2_QUESTION": "Waar kan ik hulp voor vinden?",
        "FAQ_2_ANSWER": " Op Handyhand kan je hulp vinden voor vrijwel alles. Of je nu een klusjesman, timmerman, schoonmaakhulp, loodgieter, tuinman, hondenuitlater, schilder, metselaar of iets heel anders nodig hebt, je kunt de juiste persoon voor je klus vinden op Handyhand.",
        "FAQ_3_QUESTION": "Hoe gebruik je Handyhand?",
        "FAQ_3_ANSWER": "Het is heel makkelijk om Handyhand te gebruiken. Het enige wat je hoeft te doen is een klus aanmaken door op 'Maak klus aan' te klikken. Geef een goede beschrijving van de klus die je uitgevoerd wilt hebben, wanneer er uiterlijk een offerte kan worden gegeven en waar het werk moet worden uitgevoerd. Je stelt een budget in dat eerlijk is en bij de klus past, of kiest voor het ontvangen van offertes. Daarna hoef je alleen maar achterover te leunen, offertes te ontvangen en je Handyhander te kiezen. Makkelijker wordt het niet!",
        "FAQ_4_QUESTION": "Hoe betaal je?",
        "FAQ_4_ANSWER": "Handyhand maakt het makkelijk en veilig om voor je klus te betalen met HandyhandPay. Wanneer je een Handyhander kiest via het platform, wordt je betaling veilig in het systeem gehouden totdat de klus is voltooid - en jij bepaalt wanneer dat is! Pas wanneer je hebt gemeld dat de klus is voltooid, wordt het geld uitbetaald aan je Handyhander. Mocht de klus om de een of andere reden niet worden uitgevoerd, dan kun je de klus annuleren en wordt je terugbetaald.",
        "FAQ_5_QUESTION": "Ik wil klussen uitvoeren en geld verdienen, kan dat?",
        "FAQ_5_ANSWER": "Ja! Ben je een goede klusjesman, een bekwame schilder, handige meubelmonteur of iets heel anders, dan is het super makkelijk om klussen bij jou in de buurt te vinden. Vind een klus die je wilt uitvoeren, stel vragen aan de klusgever of doe een bod op de klus. Handyhand maakt het makkelijk om kleine en middelgrote klussen online te krijgen via ons platform. Help mensen met het oplossen van klussen in huis en verdien vandaag nog geld met kleine klussen. Begin vandaag met geld verdienen als Handyhander!",
        "FAQ_6_QUESTION": "Hoe zit het met belasting?",
        "FAQ_6_ANSWER": "Handyhand stuurt rekeningen naar zowel jou als je Handyhander, en maakt het mogelijk om een overzicht te houden van je inkomsten op het platform, waardoor het makkelijk is om aan te geven bij de belastingdienst, wat we al onze Handyhanders sterk aanraden te doen.",
        "FAQ_7_QUESTION": "Krijg hulp of neem contact op met Handyhand Support",
        "FAQ_7_ANSWER": "Je kunt hulp krijgen door onze supportpagina te bezoeken op https://handyhand.nl/contact.",
        "FAQ_8_QUESTION": "Helpcentrum",
        "FAQ_8_ANSWER": "Handyhand heeft een FAQ waar je antwoorden kunt vinden op veelgestelde vragen. Je vindt onze FAQ op https://handyhand.nl/hulp"
      },
      "LP1": {
        "TITLE_1": "Vind hulp voor",
        "ANYTHING": "alles",
        "GARDEN": "tuin",
        "HOME": "huis",
        "IT": "computer",
        "MOVING": "verhuizing",
        "CLEANING": "schoonmaak",
        "PARTY": "feest",
        "TITLE_2": "Vrijblijvende offertes van beoordeelde en vertrouwde experts in enkele minuten",
        "PLACEHOLDER": "Ik moet...",
        "HERO_USP_1": "klanten",
        "HERO_USP_2": "klussen",
        "HERO_USP_3": "beoordelingen",
        "PAINTER": "schilderwerk",
        "CARPENTER": "timmerwerk",
        "ELECTRICIAN": "elektrawerk",
        "PLUMBING": "loodgieterswerk",
        "BRICKLAYER": "metselwerk",
        "FLOOR": "de vloer",
        "FURNITURE_ASSEMBLY": "meubelmontage",
        "FURNITURE": "de meubels",
        "APPLIANCES": "witgoed",
        "CARPORT": "de carport",
        "BIKE": "de fiets",
        "HANDYMAN": "klushulp",
        "EYEBROW": "Het grootste klussenplatform",
        "SUBTITLE": "Beschrijf je klus, ontvang offertes, kies de juiste hulp.",
        "TRUSTPILOT_ALT": "Bekijk onze beoordelingen op Trustpilot"
      },
      "SERVICE_OPTIONS": {
        "HEADLINE": "Waar heb je hulp bij nodig?",
        "HANDYMAN": "Klusjesman",
        "GARDENING": "Tuinwerk",
        "CARPENTER": "Timmerman",
        "PLUMBING": "Loodgieter",
        "PAINTER": "Schilder",
        "WASTE_COLLECTION": "Afval ophalen",
        "ELECTRICIAN": "Elektricien",
        "TECHNICIAN": "IT hulp",
        "MOVING_HELP": "Verhuishulp",
        "FURNITURE_ASSEMBLY": "Meubelmontage",
        "CLEANING": "Schoonmaak",
        "WINDOW_CLEANING": "Ramen lappen",
        "HEDGE_TRIMMING": "Heg knippen"
      },
      "REVIEWS_TITLE": "Bekijk wat anderen hebben laten doen",
      "REVIEWS_SUBTITLE": "Meer dan {{tasks}} klussen zijn al opgelost via Handyhand.",
      "REVIEWS_DONE_BY": "Uitgevoerd door",
      "REVIEWS_RATING_LABEL": "{{rating}} van de 5 sterren"
    },
    "HOW_TO_GUIDE": {
      "META_TITLE": "2026 Doe-het-zelf gidsen",
      "META_DESC": "Vind al onze doe-het-zelf gidsen voor verschillende diensten hier."
    },
    "HUB": {
      "SCHEMA": {
        "DESC": "Artikelen, tips en trucs, gidsen en prijsschattingen. "
      },
      "READING_TIME": "Leestijd",
      "GUIDE_TITLE": "Gidsen",
      "TIPS_TITLE": "Tips en trucs binnen ",
      "TIPS_DESC": "Vind hier tips en trucs voor alles in huis",
      "PRICE_GUIDE_TITLE": "Prijsgidsen binnen ",
      "PRICE_DATA_TITLE": "Prijsgegevens van {{replace}} klussen",
      "VERTICAL_TITLE": "Ontvang gratis offertes ",
      "SUB_HUB_TITLE": "Andere categorieën",
      "PRICE_DATA_DESC": "Prijsgegevens van alle soorten klussen van het Handyhand platform",
      "SYNTHETIC_PRICE_GUIDE_TITLE": "Indicatieve prijsschattingen",
      "SYNTHETIC_PRICE_GUIDE_DESC": "We hebben enkele indicatieve prijsschattingen voor je verzameld",
      "DEEPLINK_GUIDES": "Gidsen",
      "DEEPLINK_PRICE_GUIDES": "Prijsgidsen",
      "DEEPLINK_TIPS_TRICKS": "Tips en trucs",
      "DEEPLINK_SERVICES": "Diensten",
      "LOCAL_SERVICES_LINK": "Bekijk lokale diensten hier",
      "MINI_SERVICES_LINK": "Bekijk mini-diensten hier"
    },
    "TIPS_INDEX": {
      "SUB_CATEGORIES_TITLE": "Tips per subcategorie",
      "DIRECT_TIPS_TITLE": "Overige tips in deze categorie",
      "ALL_IN_PARENT": "Bekijk alle tips in",
      "H1_PREFIX": "Alle tips in"
    },
    "MINI_SERVICES_INDEX": {
      "SUB_CATEGORIES_TITLE": "Mini-diensten per subcategorie",
      "DIRECT_SERVICES_TITLE": "Overige mini-diensten in deze categorie",
      "ALL_IN_MAIN": "Bekijk alle mini-diensten in",
      "H1_PREFIX": "Alle mini-diensten in",
      "META_DESCRIPTION": "Bekijk al onze mini-diensten in {{category}}. Vind de juiste dienst voor jouw behoefte."
    },
    "LOCAL_SERVICES_INDEX": {
      "H1_PREFIX": "Alle lokale bedrijven binnen"
    },
    "INSPIRATION": {
      "META_TITLE": "- Snelle weg naar directe en betaalbare oplossing -",
      "DESC_H": "Particulieren bieden betaalbare hulp voor klussen met betrekking tot ",
      "CREATE": ". Maak je klus aan en ontvang vrijblijvende offertes",
      "TITLE": "Hier zijn de meest populaire type klussen op Handyhand, inspiratie voor thuis",
      "DESC": "Hier vindt u een overzichts van de klussen waarvoor het vaakst hulp wordt gezocht op Handyhand. Bij Handyhand kun je een reeks van de meest populaire klussen vinden die in huis zijn uitgevoerd. Onze website is een grote bron van inspiratie voor iedereen die zijn huis wilt updaten met nieuwe projecten. Je kunt alles vinden van kleine reparaties tot uitgebreide renovaties die je huis een geheel nieuwe look kunnen geven. We hebben een lijst samengesteld van de meest gevraagde klussen, zodat je een idee kunt krijgen van wat mogelijk is in je eigen huis. Blader door onze selectie van klussen en krijg ideeën over hoe je je huis kunt verbeteren en het functioneler en mooier kunt maken.",
      "HELP": "Handyhanders die hulp bieden bij klussen met betrekking tot",
      "PREV": "Inspiratie van eerder aangemaakte klussen over"
    },
    "DAMAGE_COMPENSATION": {
      "HEAD1": "Bescherming",
      "HEAD2": "Schadevergoeding",
      "HEAD3": "Gedekt door onze schadevergoeding",
      "USP1": "Het is fijn om gedekt te zijn, mocht er iets misgaan - daarom hebben we een schadevergoeding beschikbaar die je helpt klussen met een gerust hart uit te voeren.",
      "USP2": "Handyhands schadevergoeding dekt eventuele materiële schade die zou kunnen ontstaan tijdens het uitvoeren van een klus bij derden terwijl de klus wordt uitgevoerd.",
      "USP3": "Handyhands schadevergoeding wordt geleverd door ons eigen schadevergoedingsteam - zodat je je altijd veilig kunt voelen wanneer je hulp krijgt via Handyhand.",
      "INFO": "Je klus is gedekt door onze schadevergoeding",
      "HEADLINE": "Handyhand Schadevergoeding",
      "SUB_HEADLINE_1": "We zijn er voor je",
      "SUB_P_1": "Wanneer Handyhand je helpt bij het uitvoeren van een klus, ben je automatisch gedekt door onze schadevergoeding.",
      "SUB_HEADLINE_2": "Uitgebeide schadevergoeding",
      "SUB_P_2": "Onze schadevergoeding geeft je zekerheid en gemoedsrust wanneer je hulp krijgt via Handyhand.",
      "INTRO_HEAD_1": "Dekking",
      "INTRO_TEXT_1": "Handyhands schadevergoeding dekt schade tot {{maxAmount}} voor eventuele materiële schade die zou kunnen ontstaan tijdens het uitvoeren van een klus bij derden terwijl de klus uitgevoerd wordt. Dit is een aanvulling op andere verzekeringen die jij zelf hebt of de dienstverlener heeft.",
      "HERO_SUB": "Wanneer je een klus laat uitvoeren via Handyhand, ben je automatisch gedekt door onze schadevergoeding – zonder extra kosten.",
      "CHIP_COVERAGE": "Dekking tot {{maxAmount}}",
      "CHIP_AUTOMATIC": "Automatisch gedekt",
      "TOC_TITLE": "Op deze pagina",
      "META_TITLE": "Schadevergoeding – dekking tot {{maxAmount}}",
      "META_DESC": "Lees over Handyhands schadevergoeding: wat gedekt is, hoe je schade meldt en welke limieten en termijnen gelden.",
      "TERMS": {
        "INTRO": {
          "P1": "Wanneer u een taak boekt via het Handyhand-platform, kunt u onder de onderstaande voorwaarden in aanmerking komen voor onze schadevergoedingsregeling. De regeling is een beperkte, vrijwillige vergoeding van Handyhand en is geen verzekering of garantie. Ze doet geen afbreuk aan het feit dat de overeenkomst voor het werk rechtstreeks tussen u en de uitvoerder wordt gesloten.",
          "P2": "De schadevergoedingsregeling van Handyhand kan een vergoeding tot {{maxAmount}} per taak uitkeren voor bepaalde plotselinge en onverwachte materiële schade die ontstaat tijdens de uitvoering van een taak die via Handyhand is geboekt en betaald. De regeling is een aanvulling op eventuele gewone verzekeringen van de opdrachtgever en de Handyhander en is onderworpen aan de voorwaarden, beperkingen en uitzonderingen die hieronder staan vermeld.",
          "P3": "Onder \"materiële schade\" wordt verstaan: fysieke schade aan roerende zaken, inboedel, gebouwen of andere stoffelijke zaken. De regeling dekt geen zuivere vermogensschade, bedrijfsschade, gederfde inkomsten of ander indirect verlies."
        },
        "HOW_IT_WORKS": {
          "TITLE": "Hoe werkt de schadevergoeding?",
          "P1": "U kunt onder de schadevergoedingsregeling vallen wanneer de taak via Handyhand is geboekt en betaald, en de schade ontstaat tijdens de uitvoering van het werk zelf.",
          "P2": "De regeling geldt alleen in de periodes waarin het werk daadwerkelijk wordt uitgevoerd. Schade die daarna ontstaat, valt er niet onder, ook niet als de taak nog niet als voltooid is gemarkeerd.",
          "P3": "De schade moet uiterlijk 14 dagen nadat de taak als voltooid of geannuleerd is gemarkeerd, worden gemeld."
        },
        "COVERAGE": {
          "TITLE": "Wat dekt de schadevergoeding?",
          "P1": "De schadevergoeding van Handyhand geldt voor bepaalde materiële schade die direct het gevolg is van een plotseling en eenmalig ongeluk tijdens het werk.",
          "P2": "De regeling dekt geen schade die het gevolg is van gebrekkige uitvoering, foutieve installatie, een verkeerde werkwijze, onvoldoende vakkennis of het niet naleven van geldende regels en instructies."
        },
        "LIMITS": {
          "TITLE": "Bedragsgrenzen",
          "LEAD": "Voor de schadevergoedingsregeling gelden de volgende bedragsgrenzen:",
          "ITEMS": {
            "MAXIMUM": "Maximale vergoeding: {{maxAmount}} per taak.",
            "MINIMUM": "Schade onder {{minAmount}} wordt niet in behandeling genomen.",
            "DEDUCTIBLE": "Op alle schadevergoedingen wordt een aftrek van {{deductibleAmount}} toegepast.",
            "DOCUMENTED_LOSS": "De vergoeding kan nooit hoger zijn dan het aangetoonde financiële verlies.",
            "INDIRECT_LOSS": "Er wordt geen vergoeding gegeven voor indirect verlies of gevolgschade."
          }
        },
        "COVERED_EXAMPLES": {
          "TITLE": "Voorbeelden van schade die gedekt kan zijn:",
          "ITEMS": {
            "PAINT": "Verf die op de vloer wordt gemorst tijdens het schilderen van muren.",
            "SHELF": "Een plank valt tijdens de montage en breekt.",
            "MOVING_BOX": "Een verhuisdoos valt en de inhoud raakt beschadigd.",
            "WINDOW": "Een ruit sneuvelt bij het in- of uitdragen van meubels.",
            "BUILDING": "Schade aan bouwdelen, bijv. stucwerk, muren, deurkozijnen of vloeren, veroorzaakt door een plotseling ongeluk tijdens de uitvoering van de taak."
          }
        },
        "NOT_COVERED": {
          "TITLE": "Wat valt niet onder de schadevergoeding?",
          "ITEMS": {
            "AUTHORISATION": "Schade die ontstaat als de uitvoerder niet beschikt over de vereiste vergunningen of erkenningen voor het werk, bijv. werk in natte ruimtes of elektrisch werk.",
            "TASK_DESCRIPTION": "Schade die het gevolg is van onjuiste of misleidende taakomschrijvingen van uw kant als klant.",
            "INTENT": "Schade die opzettelijk door de uitvoerder is veroorzaakt.",
            "GROSS_NEGLIGENCE": "Schade als gevolg van grove nalatigheid van uw kant. <em>Grove nalatigheid verwijst naar een aanzienlijke afwijking van normaal, verantwoordelijk gedrag – bijvoorbeeld het negeren van duidelijke risico's of doorgaan met het werk nadat u duidelijk is gevraagd te stoppen.</em>",
            "WORKMANSHIP": "Schade en verlies als gevolg van gebrekkige uitvoering, foutieve installatie, een verkeerde werkwijze, onvoldoende vakkennis of het niet naleven van geldende regels en instructies.",
            "INDIRECT_LOSS": "Indirect verlies, bedrijfsschade, afgeleide financiële schade of gevolgschade die voortvloeit uit de oorspronkelijke schade."
          },
          "P1": "Bij taken waarvoor de wet een erkenning of bijzondere goedkeuring vereist, is het de verantwoordelijkheid van de klant om ervoor te zorgen dat de uitvoerder over de benodigde erkenning beschikt. Het ontbreken daarvan kan ertoe leiden dat er geen schadevergoeding wordt uitgekeerd."
        },
        "SETTLEMENT": {
          "TITLE": "Reparatie, vervanging of financiële vergoeding – wat geldt er?",
          "P1": "Handyhand bepaalt na een concrete beoordeling of er een financiële vergoeding wordt gegeven op basis van reparatie of vervanging. Bij de beoordeling wordt onder meer gekeken naar de reparatiemogelijkheden, de kosten en de leeftijd en staat van het voorwerp.",
          "P2": "Handyhand beoordeelt elke melding afzonderlijk op basis van de ontvangen documentatie. Het is aan de klant om de omvang, oorzaak en waarde van de schade aannemelijk te maken."
        },
        "PRIVATE_INSURANCE": {
          "TITLE": "Heb ik nog steeds een eigen verzekering nodig?",
          "P1": "Ja, we raden u aan uw eigen verzekering te behouden, omdat de schadevergoedingsregeling alleen bepaalde schade in verband met de taak dekt en onderworpen is aan bedragsgrenzen en uitzonderingen.",
          "P2": "Als er schade ontstaat, kan het afhankelijk van de situatie zinvol zijn om die ook bij uw eigen verzekering en/of de verzekering van de uitvoerder te melden. U kunt de schade tegelijk bij Handyhand melden, en wij helpen u met welke documentatie doorgaans nodig is voor de regeling.",
          "P3": "We hopen dat alles soepel verloopt met de taak die u hebt geboekt! Heeft u vragen over de schadevergoedingsregeling of hulp nodig bij het melden van schade, dan kunt u altijd contact met ons opnemen."
        },
        "HOW_TO_APPLY": {
          "TITLE": "Hoe vraag ik een schadevergoeding aan?",
          "P1": "<strong>Voordat u een schadevergoeding aanvraagt, moet de taak op het Handyhand-platform zijn afgerond of geannuleerd.</strong>",
          "P2": "Zodra de taak is afgerond of geannuleerd, moet de schade zo snel mogelijk worden gemeld via het <a href=\"{{applicationUrl}}\">aanvraagformulier</a> van Handyhand, en uiterlijk 14 dagen nadat de taak is afgerond of geannuleerd.",
          "P3": "<strong>Let op: als u de taak afrondt, wordt de betaling vrijgegeven en uitbetaald aan de dienstverlener.</strong> Zodra het geld is uitbetaald, kan Handyhand het niet meer terughalen bij de dienstverlener.",
          "P4": "Denkt u dat er schade is ontstaan, of dat de taak niet moet worden afgerond? Rond de taak dan niet af voordat de situatie is opgehelderd. In plaats daarvan kunt u <a href=\"{{cancellationUrl}}\">een annulering aanvragen</a> of contact opnemen met Handyhand voor hulp.",
          "P5": "Wordt de annulering betwist en komt u niet tot een compromis, dan kunt u meer lezen over <a href=\"{{disputeUrl}}\">het conflictproces van Handyhand</a>. Het conflictproces kan tot 14 dagen duren. Handyhand kan geen oplossing garanderen, maar kan helpen de zaak te beoordelen en een compromis voor te stellen.",
          "CHECKLIST": {
            "TITLE": "Dit moet u klaar hebben wanneer u aanvraagt",
            "LEAD": "Zodat we uw schademelding zo snel en zorgvuldig mogelijk kunnen behandelen, kunt u het volgende het beste klaar hebben voordat u het formulier invult:",
            "ITEMS": {
              "TASK": "Gegevens over de betreffende taak, bijv. de titel van de taak of een link ernaartoe.",
              "DESCRIPTION": "Een korte en concrete beschrijving van wat er is gebeurd, wanneer de schade ontstond en hoe de schade samenhangt met de uitvoering van de taak.",
              "PHOTOS": "Foto's of andere documentatie die de schade en de omvang ervan duidelijk laten zien.",
              "COMMUNICATION": "Eventuele communicatie met de dienstverlener over de schade, als die kan helpen verduidelijken wat er is gebeurd.",
              "VALUE": "Bewijs van de waarde van het voorwerp of de schade, bijv. een bon, factuur, taxatie of andere relevante documentatie.",
              "REPAIR_COST": "Bewijs van reparatie- of vervangingskosten, bijv. een offerte, taxatie of factuur.",
              "OWN_INSURANCE": "Als de schade bij uw eigen verzekering is gemeld, houd dan ook de relevante documentatie daarvan bij de hand, bijv. de beslissing, het eigen risico of andere relevante informatie."
            },
            "NOTE_PROPERTY": "Als de schade betrekking heeft op onroerend goed of bouwdelen, bijv. stucwerk, muren of vloeren, kan vaak een offerte van een vakman of een deskundige beoordeling worden gebruikt in plaats van een oorspronkelijke aankoopprijs.",
            "NOTE_REPAIR": "Als het voorwerp mogelijk kan worden gerepareerd, kunnen we om een reparatieofferte vragen – of om een deskundige beoordeling die bevestigt dat reparatie niet mogelijk of economisch niet verantwoord is.",
            "OUTRO": "Handyhand beoordeelt de zaak op basis van de documentatie die u instuurt. Het is daarom belangrijk dat u de schade zo concreet mogelijk beschrijft en de documentatie bijvoegt die de oorzaak, omvang en waarde van de schade aannemelijk kan maken."
          }
        },
        "REAL_CASES": {
          "TITLE": "Voorbeelden uit de praktijk",
          "LEAD": "Om het makkelijker te maken te begrijpen wat we dekken, hebben we een aantal voorbeelden verzameld op basis van eerdere beslissingen. Houd er rekening mee dat elke zaak afzonderlijk wordt beoordeeld op basis van de ingestuurde documentatie.",
          "APPROVED": {
            "TITLE": "Wat we doorgaans goedkeuren: plotselinge ongelukken",
            "ITEMS": {
              "DROPPED": "Gevallen voorwerpen: Een uitvoerder laat een zwaar voorwerp op een kookplaat vallen, die versplintert.",
              "HANDLING": "Schade bij het hanteren: Een plaat of paneel breekt plotseling doordat het omvalt of valt tijdens het werk zelf.",
              "ASSEMBLY": "Cosmetische ongelukken bij montage: Nieuwe meubels krijgen diepe krassen of deuken doordat gereedschap of onderdelen wegglijden tijdens het in elkaar zetten.",
              "MOVING": "Verhuisschade: Een meubelstuk krijgt een stoot of kras terwijl het door een deuropening of een trap op wordt gedragen."
            }
          },
          "REJECTED": {
            "TITLE": "Wat we doorgaans afwijzen: slecht vakmanschap of ontbrekende erkenning",
            "ITEMS": {
              "INSTALLATION": "Foutieve montage en slecht vakmanschap: Een wastafel of kraan wordt verkeerd geïnstalleerd, waardoor er een lekkage ontstaat. Dit wordt gezien als gebrekkige uitvoering, niet als een ongeluk.",
              "FORESEEABLE": "Voorzienbare gevolgen: Stof van schuren of zagen verspreidt zich door het huis. Dit is een natuurlijk gevolg van het werkproces en had voorkomen kunnen worden door af te dekken.",
              "WEAR": "Oude schade en corrosie: Een leidingschade wordt ontdekt na het schoonmaken, maar technisch onderzoek toont aan dat de schade het gevolg is van jarenlange corrosie en roest.",
              "METHOD": "Verkeerde methode: Er ontstaan krassen of vlekken doordat de uitvoerder een verkeerde schuurmethode of een verkeerd schoonmaakmiddel heeft gebruikt op een kwetsbaar oppervlak.",
              "CONSEQUENTIAL": "Gevolgschade door fouten: Een motor of machine gaat kapot doordat een reparatie niet correct is uitgevoerd. Dit wordt gezien als een gevolg van gebrekkige uitvoering en niet als een plotseling ongeluk tijdens het werk.",
              "ASBESTOS": "Werken met asbest zonder erkenning: Schade of verontreiniging die ontstaat bij werkzaamheden met asbest wordt afgewezen als de uitvoerder niet over de wettelijk vereiste erkenning beschikt. Het is uw eigen verantwoordelijkheid als klant om ervoor te zorgen dat de uitvoerder een geldig bewijs van erkenning kan tonen voordat het werk begint."
            }
          },
          "NOTE_PARTIAL": "Als schade zowel het gevolg is van een gedekt ongeluk als van omstandigheden die niet onder de regeling vallen, kan Handyhand na een concrete beoordeling de vergoeding beperken tot het deel van de schade dat direct toe te schrijven is aan het gedekte ongeluk."
        }
      }
    },
    "PRICE_GUIDE": {
      "PRICE_GUIDE": "Prijsgids",
      "INDICATIVE_PRICES": "Richtprijzen",
      "LOW": "Laag",
      "MEDIUM": "Gemiddeld",
      "HIGH": "Hoog",
      "RELATED": "Gerelateerde artikelen",
      "META": "Prijsgidsen",
      "META_TITLE": "Prijsgidsen Handyhand 2026",
      "META_DESC": "Vind hier al onze prijsgidsen voor verschillende diensten. Vraag online een offerte aan voor hulp in en rond huis en tuin.",
      "SIMILAR_TASKS": "Vergelijkbare klussen gecontroleerd",
      "AVERAGE_OFFERS": "Gemiddelde offertes per klus",
      "AVERAGE_PRICE": "Gemiddelde bod voor klussen",
      "SIMILAR_TASKS_TITLE": "Vergelijkbare klussen",
      "AVG_OFFER_SIMILAR_TASK": "Gemiddelde bod",
      "OFFERS": "Offertes",
      "LOCATION": "Locatie",
      "BUDGET": "Budget",
      "CREATED_AT": "Aangemaakt op",
      "DESCRIPTION": "Beschrijving",
      "TASK_EXAMPLE": "Voorbeeld van een echte klus",
      "TASK_EXAMPLE_DESC": "Hier is een voorbeeld van een echte klus die is opgelost op Handyhand,",
      "TASK_EXAMPLE_DESC_2": "Dit is een goede manier om een idee te krijgen van wat anderen hebben betaald voor een vergelijkbare klus.",
      "CALCULATE_PRICE": "Probeer prijscalculator",
      "FROM_LOCATION": "Van",
      "TO_LOCATION": "Naar",
      "DISTANCE": "Afstand",
      "STAIRS": "Trappen",
      "ELEVATOR": "Lift",
      "NO_STAIRS": "Geen trappen",
      "KM": "km",
      "ACCESSIBILITY": "Toegankelijkheid",
      "PEOPLE_WHO_COMPLETE": "Mensen die vergelijkbare klussen voltooien",
      "COMPLETED_TASKS": "voltooide klussen",
      "AVERAGE_RATING": "Gemiddelde beoordeling",
      "NO_RATING": "Nog geen beoordeling",
      "RELATED_GUIDES": "Vergelijkbare prijsgidsen",
      "SPECIALIZES_IN": "Specialiseert in",
      "AI_OVERVIEW": {
        "TITLE": "Prijsvergelijking op basis van Handyhand klussen",
        "DESCRIPTION": "Met meer dan 65.000 prijsgidsen hebben we het meest complete prijsoverzicht op het internet. Vind de prijs voor je klus in minder dan 2 seconden.",
        "SEARCH_PLACEHOLDER": "Zoek in onze prijsschattingen...",
        "SHOW_ALL": "Toon alles",
        "LOADING_GUIDES": "Prijsgidsen laden...",
        "SEE_ALL": "Bekijk alles",
        "SERVICES": "diensten",
        "SEARCHING": "Zoeken"
      }
    },
    "SEO_CATEGORIES": {
      "TITLE": "Categorieën",
      "META_TITLE_JOBS": "Vind klussen in alle categorieën",
      "META_DESC_JOBS": "Met ons online platform kun je elke dag nieuwe klussen vinden in je vakgebied en geld verdienen.",
      "META_TITLE_JOBS_LOCAL": "Vind lokale klussen",
      "META_DESC_JOBS_LOCAL": "Vind en solliciteer op lokale klussen in jouw omgeving met het Handyhand platform",
      "META_TITLE_VERTICAL": "Laat je klussen in huis uitvoeren",
      "META_DESC_VERTICAL": "Wil je particuliere hulp? Krijg hulp van particulieren om je klussen in huis en tuin op te lossen ✓33% lagere prijzen ✓Snel en makkelijk",
      "META_TITLE_SERVICES_LOCAL": "Lokale diensten",
      "META_DESC_SERVICES_LOCAL": "Vind betrouwbare lokale diensten en dienstverleners bij jou in de buurt.",
      "DESC": "Of je nu hulp nodig hebt bij reparaties, installaties, onderhoud of renovatie, we hebben een categorie voor je. Onze categorieën omvatten verschillende gebieden zoals loodgieter, elektricien, timmerwerk, schilderwerk, tuinwerk, schoonmaak, verhuizen en nog veel meer. Of je nu een klein of groot project hebt, je kunt een categorie vinden die past bij je wat je nodig hebt.",
      "EARN_H1": "Vind freelance klussen - Verdien vandaag geld",
      "EARN_SUB": "Handyhand is Nederlands beste marktplaats voor alle soorten werk, van klusjesman tot schoonmaakhulp tot tuinman. Meld je nu aan en verdien geld!"
    },
    "TIPS": {
      "BROWSER_TITLE": "Tips en trucs | Handyhand",
      "TITLE": "Vind tips en trucs voor alles in huis",
      "TIPS": "Tips en trucs voor al je projecten",
      "SEARCH": "Zoek tussen 6000+ verschillende tips hier..."
    },
    "AI_PRICE_GUIDES_INDEX": {
      "H1_PREFIX": "Prijsgidsen voor",
      "INTRO_PART_1": "Bekijk een gedetailleerd prijsoverzicht voor klussen in",
      "INTRO_PART_2": ", om je te helpen kosten te schatten en weloverwogen beslissingen te nemen op basis van data van ons platform.",
      "LOADING": "Prijsgidsen laden...",
      "EMPTY": "Geen prijsgidsen gevonden in deze categorie.",
      "BREADCRUMB_INDEX": "Prijsgidsen index",
      "META_TITLE_PREFIX": "Prijsdata voor",
      "META_DESC_PREFIX": "Vind klusdata voor",
      "META_DESC_SUFFIX": " om je te helpen kosten te schatten en weloverwogen beslissingen te nemen."
    },
    "AI_PRICE_DATA_OVERVIEW": {
      "BREADCRUMB": "Prijsdata",
      "META_TITLE": "Prijsdata over klussen: klusjesman, tuinwerk en {{tasks}}+ verschillende klussen",
      "META_DESC": "Bekijk prijsdata van klussen die vakmensen en klusjesmannen op de marktplaats van Handyhand hebben uitgevoerd, o.a. timmerlieden, metselaars, "
    },
    "PRESS_ROOM": {
      "INTRO": "Het persteam van Handyhand helpt journalisten en anderen die interviews, statistieken, achtergrondinformatie, foto's enz. nodig hebben.",
      "IMAGE_SECTION_WORKERS": "Foto's van mensen die werk doen met Handyhand",
      "IMAGE_SECTION_TEAM": "Foto's van het team van Handyhand",
      "IMAGE_SECTION_PLATFORM": "Foto's van het platform"
    },
    "EARNINGS_CALCULATOR_IMAGES": {
      "FEMALE_HANDYMAN": "vrouwelijke klusjesman",
      "TOOL_ICON": "gereedschapsicoon",
      "BOY_CLEANING": "jongen die schoonmaakt",
      "CLEANING_ICON": "schoonmaak icoon",
      "GARDENER": "tuinman"
    },
    "HOW_IT_WORKS_PAGE": {
      "HERO_ALT": "klusjesman marktplaats deeleconomie platform vind klussen online in Nederland"
    },
    "PRIVACY_POLICY": {
      "ADDRESS_LINE": "Kopenhagen K 1055",
      "COOKIE_SETTINGS_BUTTON": "Cookie-instellingen wijzigen",
      "COOKIE_SETTINGS_UNAVAILABLE": "De cookiebanner kon niet worden geopend. Gebruik je een adblocker of privacy-extensie, sta deze site dan toe en probeer het opnieuw, of verwijder je cookies voor deze site en herlaad de pagina: de banner verschijnt dan bij je volgende bezoek."
    },
    "HANDYHANDER_LANDING": {
      "ALT_EARN": "platform verdien geld",
      "ALT_CARPENTER": "Handyhander timmerman"
    },
    "LANDING_TASK_EXAMPLES": {
      "OWNER_ALT": "Klusgever voor voltooide klussen online"
    },
    "ACCOUNT_DELETION": {
      "TITLE": "Account verwijderen",
      "INTRO_TEXT": "Om je Handyhand-account te verwijderen, volg de onderstaande stappen:",
      "STEP_1": "Log in op het account dat je wilt verwijderen",
      "STEP_2": "Klik op de knop in de rechterbovenhoek met je naam en profielfoto",
      "STEP_3": "Klik op \"Accountinstellingen\"",
      "STEP_4": "Scroll helemaal naar beneden op de pagina",
      "STEP_5": "Klik op \"Verwijder profiel\"",
      "STEP_6": "Bevestig de verwijdering door op \"Ja\" te klikken"
    },
    "VERTICAL": {
      "AVG_PRICE": "Gemiddelde prijs voor ",
      "FLEX_PRICE": "Flexibele prijs",
      "BEST_OFF": "Kies de offerte die het beste bij je past!",
      "REVIEW_TITLE": "Gemiddelde beoordelingen van",
      "REVIEW_SUB": "Gebaseerd op",
      "REVIEWS": "Beoordelingen",
      "LOC_EXPERT": "Lokale experts",
      "SELECT_EXPERT": "Kies een lokale expert, waar je ook bent in Nederland.",
      "MORE_TASKS": "Bekijk meer klussen",
      "OFFER_NOW": "Krijg nu gratis offertes",
      "OFFER_NOW_COMPANY": "Krijg offertes van vergelijkbare bedrijven",
      "OFFER_NO_TIME": "Directe offertes",
      "REC_OFFER": "Ontvang direct offertes om je klus uit te voeren!",
      "DESC_TASK_2": "Vul een kort formulier in en ontvang offertes van particulieren en bedrijven ",
      "TASKS_CAT": "Vind klussen in de categorie",
      "EARN_H1": "Vind freelance klussen en verdien vandaag geld",
      "TIME": "Het duurt slechts 2 minuten en het is gratis",
      "TIME_2": "Het duurt slechts 2 minuten en het is gratis",
      "TRUE_REVIEWS": "Echte beoordelingen",
      "RELATED_SERV": "Gerelateerde diensten",
      "REVIEW_SELF": "Beoordeel zelf - alle klussen krijgen een beoordeling!",
      "EARN_SUB": "Handyhand is Nederlands beste marktplaats voor alle soorten werk, van klusjesman tot schoonmaakhulp tot tuinman. Meld je nu aan en verdien geld!",
      "SEARCH_JOB": "Zoek werk",
      "JOB_TASK_AROUND": "Bekijk welke klussen mensen bij jou in de buurt uitgevoerd willen hebben...",
      "FIND_JOBS": "Vind klussen in",
      "FIND_JOBS_2": "de categorie. Betaald werk met klussen in",
      "MIT_ID": "DigiD geverifieerd",
      "FACEBOOK": "Facebook geverifieerd",
      "DIGITAL_ID": "Digitale ID geverifieerd",
      "BANK": "Bank geverifieerd",
      "MOBILE": "Mobiel geverifieerd",
      "COMPANY": "Bedrijf geverifieerd",
      "TOP_STAR_REVIEW": "10+ vijfsterrenbeoordelingen",
      "BADGE_HEADER": "Verificaties",
      "BADGES": {
        "WHAT_ARE_BADGES": "Wat zijn verificaties?",
        "BADGES_DESCRIPTION": "Verificaties worden weergegeven wanneer bepaalde ID-documenten en kwalificaties zijn geverifieerd. Het is een belangrijke functie die helpt om vertrouwen op te bouwen in onze community.",
        "READ_MORE": "Lees meer over verificaties",
        "HERE": "hier",
        "MIT_ID_DESCRIPTION": "Deze verificatie geeft aan dat een persoon zijn identiteit heeft geverifieerd via DigiD. DigiD is de digitale identificatieoplossing van Nederland en biedt veilige authenticatie en digitale mogelijkheden voor ondertekening.. Door zich te verifiëren met DigiD, tonen gebruikers hun officiële identiteit aan en krijgen toegang tot beveiligde digitale diensten.",
        "BANK_DESCRIPTION": "Deze verificatie geeft aan dat de bankrekening van een persoon is geverifieerd. Bankverificatie zorgt voor veilige financiële transacties en voegt een extra laag vertrouwen toe aan het platform. Het verificatieproces bevestigt dat de gebruiker legitieme toegang heeft tot de opgegeven bankrekening.",
        "MOBILE_DESCRIPTION": "Deze verificatie geeft aan dat het mobiele nummer van een persoon is geverifieerd. Doorhun mobiele nummer te bevestigen, zorgen ze voor een veilige en betrouwbare verbinding met ons platform. Het verificatieproces is eenvoudig en rechttoe rechtaan. We sturen een SMS-verificatiecode naar het mobiele nummer van de Handyhander om de authenticiteit te bevestigen. Dit zorgt ervoor dat het nummer daadwerkelijk eigendom is van de Handyhander en voegt een extra beveiligingslaag toe aan hun account.",
        "COMPANY_DESCRIPTION": "Deze verificatie geeft aan dat een bedrijf is geverifieerd op ons platform. Bedrijfsverificatie zorgt ervoor dat het bedrijf legitiem en geregistreerd is, wat gebruikers vertrouwen geeft dat ze werken met een geverifieerd bedrijft. Het verificatieproces omvat het controleren van bedrijfsregistratie, contactgegevens en andere relevante bedrijfsdetails.",
        "TOP_STAR_REVIEW_DESCRIPTION": "Deze verificatie geeft aan dat een gebruiker 10 of meer geverifieerde 5-sterren beoordelingen heeft ontvangen op zijn profiel. Deze prestatie toont uitzonderlijke servicekwaliteit en betrouwbaarheid aan. Het laat zien dat meerdere klanten consistent positieve ervaringen hebben gehad. Gebruikers met deze badge hebben bewezen dat ze in staat zijn om werk van hoge kwaliteit te leveren en klanttevredenheid te handhaven."
      },
      "PRICE_SUGGESTER_TITLE": "Prijscalculator",
      "PRICE_SUGGESTER_DESC": "Beschrijf je klus en ontvang een online schatting van de best beoordeelde aanbieders, in minder dan 1 minuut",
      "OR": "Of",
      "WHY": {
        "1": "Waarom een",
        "2": "inhuren met Handyhand?",
        "EASE": "Handyhand maakt het makkelijk om een",
        "WITHIN_CAT": "te vinden om te helpen met je klus in de categorie",
        "OTHER_USERS": "Andere gebruikers uit",
        "FOUND_LABOUR": "vonden bijvoorbeeld een bekwame en betaalbare",
        "HELP": "om te helpen met klussen zoals:",
        "USP_1": "Met Handyhand kan je dus makkelijk hulp vinden van de beste en meest prijsgunstige",
        "IN_ZIP": "in postcode:",
        "PRICE_IN_CAT": "De prijs van klussen in de categorie",
        "PRICE_RES": "kan variëren naar je behoeften. De meeste klussen in deze categorie ontvangen echter meestal vrijblijvende offertes in het prijsbereik"
      },
      "MINI_VERTICAL": {
        "STATS": {
          "TITLE": "Statistieken",
          "TASKS_COMPLETED": "Klussen voltooid dit jaar",
          "AVERAGE_OFFERS": "Gemiddelde offertes per klus",
          "AVERAGE_PRICE": "Gemiddelde offerteprijs",
          "FOOTER": "Statistieken van de laatste klussen op Handyhand over de afgelopen 4 jaar."
        }
      }
    },
    "NOT_FOUND": {
      "TITLE": "Pagina niet gevonden",
      "LINKS_HEADER": "Vind wat je zoekt"
    }
  },
  "TOAST_MESSAGES": {
    "WARNING": {
      "TITLE": "Je klus moet een titel hebben",
      "DESC": "Je klus moet een beschrijving hebben van min. 25 tekens"
    }
  },
  "TOOLS": {
    "PRICE_SUGGESTER": {
      "CALC_PRICE": "Bereken prijsschatting",
      "CALC_ESTIMATE": "Schatting berekenen",
      "HEADER": "Prijscalculator",
      "INTRO_DESC": " Beschrijf je klus en ontvang een online schatting van de best beoordeelde Handyhanders, in minder dan 1 minuut",
      "ESTIMATE": "Schatting",
      "MIN": "Minimaal 25 tekens",
      "INTRO": "Klussen die anderen voor een vergelijkbaar budget hebben laten uitvoeren",
      "ONLY": "*Alleen op Handyhand",
      "PAY": "Betaald:",
      "DESC": "BESCHRIJVING",
      "MORE_RES": "Toon meer resultaten",
      "TASK_COMP": "kreeg offertes op deze klus",
      "STEP_1": "Beschrijf je klus",
      "STEP_2": "Waar en wanneer",
      "STEP_3": "Ontvang een online schatting in seconden",
      "USP_1": "Gebaseerd op {{tasks}}+ klussen",
      "USP_2": "Gebruikt AI om prijs te berekenen",
      "USP_3": "Matcht met echte klussen",
      "TITLE_LABEL": "Titel van de klus",
      "DESCRIPTION_LABEL": "Beschrijf je klus",
      "TITLE_PREFIX": "Titel van de klus, bijv. ",
      "TITLE": "Titel van de klus, bijv. Hulp bij het verplaatsen van een bank",
      "DESCRIPTION": "Wees zo precies mogelijk in je beschrijving",
      "TIPS_TITLE": "Tips om een nauwkeuriger bod te krijgen",
      "RELOAD_TIPS": "Laad meer tips",
      "LOADING_TIPS": "Tips laden...",
      "RELOAD_TIPS_TOOLTIP": "Werk je beschrijving bij om nieuwe tips te zien"
    }
  },
  "PLACEHOLDERS": {
    "TO": "naar",
    "I_CHAR": "in",
    "I": "Inhoudsopgave",
    "REL_ART": "Ontdek meer artikelen in de categorie:",
    "REVIEW": "Laatste beoordeling",
    "VERIF": "Verificaties",
    "SIM_TASKS": "Vergelijkbare klussen in: ",
    "STARS": "sterren",
    "RELATED_GUIDES": "Gerelateerde gidsen"
  },
  "FOOTER": {
    "LINK_APP": "App",
    "LINK_BLOG": "Blog",
    "LINK_UPDATES": "Updates",
    "FREELANCE_CALCULATOR": "Freelance vergoeding calculator",
    "HEAD_CAT_LINKS": {
      "HANDYMAN": {
        "LABEL": "Klusjesman"
      },
      "GARDENING": {
        "LABEL": "Tuinman"
      },
      "MOVING": {
        "LABEL": "Verhuizer"
      },
      "CLEANING": {
        "LABEL": "Schoonmaak"
      },
      "WASTE": {
        "LABEL": "Afval ophalen"
      },
      "FURNITURE": {
        "LABEL": "Meubelmontage"
      },
      "ALL_CATEGORIES": {
        "LABEL": "Alle categorieen"
      }
    }
  },
  "SEO": {
    "SCHEMA": {
      "BREADCRUMB_HOME": "Home",
      "GUIDES_HUB_LABEL": "Gidsen",
      "TIPS_INDEX_NAME": "Tips-overzicht",
      "LOCAL_SERVICES_INDEX_NAME": "Lokale services-overzicht",
      "MINI_SERVICES_INDEX_NAME": "Mini services-overzicht",
      "INSPIRATION_INDEX_NAME": "Inspiratie",
      "TIPS_BREADCRUMB": "Tips",
      "RECYCLING_BREADCRUMB_ROOT": "Afval",
      "RECYCLING_INDEX_TYPE_CENTERS": "Recyclingcentra",
      "RECYCLING_INDEX_TYPE_GARDEN": "Tuinafval",
      "RECYCLING_INDEX_TYPE_OVERVIEW": "Recycling overzicht",
      "RECYCLING_INDEX_TYPE_BULK": "Grof vuil",
      "PRICE_GUIDE_MIDDLE_PRICE": "Middenprijs",
      "SERVICE_SUFFIX_IN_CITY": " in {{place}}",
      "SERVICE_SUFFIX_IN_REGION": " in {{place}}",
      "DEFAULT_ARTICLE_AUTHOR": "Handyhand",
      "WRITTEN_BY": "Geschreven door",
      "LANDING_CONTACT_TYPE": "Klantenservice",
      "LANDING_AVAILABLE_LANGUAGES": ["Nederlands", "Engels"]
    },
    "PRICE_GUIDE_ARTICLE": {
      "EDITOR_SUFFIX": " artikel",
      "GENRE": "Prijsschattingen en gidsen",
      "KEYWORDS": "{{category}} hulp en prijsgids 2024, online aanbiedingen, vraag een schatting aan",
      "DESCRIPTION": "Wat kost {{category}} — schattingen en een gids om iemand in te huren voor je woning? Onze prijsgids splitst de prijzen voor verschillende {{category}}-diensten."
    }
  },
  "GUIDES": {
    "AI_PRICE_GUIDE": {
      "OFFER_NAME": "{{name}} heeft bod nr. {{n}} geplaatst"
    }
  },
  "STATIC_DATA": {
    "REGIONS": {
      "aarhus": "Aarhus",
      "odense": "Odense",
      "storkoebenhavn": "Groot-Kopenhagen",
      "nordsjaelland": "Noord-Seeland",
      "bornholm": "Bornholm",
      "vestsjaelland": "West-Seeland",
      "sydsjaelland-og-oeer": "Zuid-Seeland en eilanden",
      "fyn": "Funen",
      "soenderjylland": "Zuid-Jutland",
      "midtvestjylland": "Midden-/West-Jutland",
      "nordjylland": "Noord-Jutland",
      "oestjylland": "Oost-Jutland",
      "drenthe": "Drenthe",
      "friesland": "Friesland",
      "guelders": "Gelderland",
      "groningen": "Groningen",
      "limburg": "Limburg",
      "south-holland": "Zuid-Holland",
      "overijssel": "Overijssel",
      "flevoland": "Flevoland",
      "north-holland": "Noord-Holland",
      "utrecht": "Utrecht",
      "zeeland": "Zeeland",
      "north-brabant": "Noord-Brabant"
    }
  },
  "TERMS_AND_CONDITIONS": {
    "TITLE": "Algemene Voorwaarden",
    "TOC_TITLE": "Inhoudsopgave",
    "SECTIONS": {
      "1": {
        "TITLE": "1. INLEIDING",
        "TOC": "1. INLEIDING",
        "P1": "1.1 Door gebruik te maken van de diensten op de website onder het domein www.handyhand.$$domain$$ aanvaardt het Lid de volgende algemene voorwaarden (de “Algemene voorwaarden”).",
        "P2": "1.2 De website https://handyhand.$$domain$$ wordt geëxploiteerd door Pinploy ApS, Deens registratienummer (CVR) 40 02 18 92, Siljangade 6, 2300 Kopenhagen S, Denemarken. Handyhand is bereikbaar via $$contactUrl$$.",
        "P3": "1.3 In deze Algemene voorwaarden worden de volgende definities gebruikt:",
        "DEFINITIONS": {
          "PAYMENT_ACCOUNT": "“Betaalrekening” betekent de rekening, betaalfunctie of betaalinfrastructuur bij de op dat moment gebruikte externe betalingsverwerker, momenteel Stripe, die wordt gebruikt voor reservering, betaling, terugbetaling en uitbetaling in verband met Klussen.",
          "HANDYHAND": "“Handyhand” betekent het domein www.handyhand.$$domain$$ en de onderneming daarachter, Pinploy ApS, Deens registratienummer (CVR) 40 02 18 92.",
          "HANDYHAND_PLATFORM": "“Handyhand-platform” betekent het platform van Handyhand waarop Klussen worden aangeboden.",
          "HANDYHANDER": "“Handyhander” betekent een Lid dat een Klus uitvoert.",
          "HANDYHAND_SERVICES": "“Handyhand-diensten” betekent de bemiddeling van de Klus tussen de Opdrachtgever en de Handyhander.",
          "MEMBER": "“Lid” betekent een gebruiker met een actief lidmaatschap bij Handyhand en is tevens de verzamelnaam voor een Handyhander en een Opdrachtgever.",
          "TASK": "“Klus” betekent een op het Handyhand-platform geplaatste advertentie voor een dienst die de Opdrachtgever wil laten uitvoeren.",
          "TASK_OWNER": "“Opdrachtgever” betekent een Lid dat een Klus plaatst.",
          "TASK_CONTRACT": "“Klusovereenkomst” betekent de overeenkomst tussen de Handyhander en de Opdrachtgever over de uitvoering van een Klus.",
          "TASK_PRICE": "“Klusprijs” betekent de tussen de Handyhander en de Opdrachtgever overeengekomen prijs.",
          "SERVICE_FEE": "“Bemiddelingsvergoeding” betekent de vergoeding aan Handyhand voor het beschikbaar stellen van het Platform en het leveren van de Handyhand-diensten."
        }
      },
      "2": {
        "TITLE": "2. LIDMAATSCHAP",
        "TOC": "2. LIDMAATSCHAP",
        "P1": "2.1 Alleen Leden hebben toegang tot het Handyhand-platform. Voor het gebruik van het Platform is daarom een lidmaatschap bij Handyhand vereist.",
        "P2": "2.2 Leden van Handyhand kunnen via het Platform afspraken maken over de uitvoering van Klussen.",
        "P3": "2.3 Het lidmaatschap bij Handyhand komt rechtsgeldig tot stand door:",
        "P3_LIST": {
          "1": "a) aanvaarding door het Lid van deze Algemene voorwaarden van Handyhand;",
          "2": "b) de juiste invoer door het Lid van de lidmaatschapsgegevens (naam, adres en e-mailadres) in het Handyhand-profiel. Een Lid kan zijn lidmaatschapsgegevens op elk moment wijzigen of verwijderen via de menu's “Profiel bewerken” en “Instellingen”. Als het Lid gegevens verwijdert die noodzakelijk zijn om Lid van Handyhand te kunnen zijn, eindigt het lidmaatschap automatisch."
        },
        "P4": "2.4 Bij de registratie ontvangt het Lid een bevestiging op het opgegeven e-mailadres.",
        "P5": "2.5 Om Klussen te kunnen plaatsen of een bod te kunnen uitbrengen om Klussen uit te voeren, moet het Lid zijn e-mailadres verifiëren.",
        "P6": "2.6 Handyhand kan een lidmaatschap weigeren, beperken, opschorten of beëindigen als daarvoor een objectieve reden bestaat, waaronder een ernstige of herhaalde overtreding van de Algemene voorwaarden, illegale inhoud, fraude, misbruik van het Platform of het betalingssysteem, intimidatie, veiligheidsrisico's, overtreding van wet- en regelgeving of gedrag dat de werking van het Platform, andere Leden of Handyhand ernstig schaadt. Handyhand verstrekt het Lid uiterlijk op het moment waarop de beslissing van kracht wordt een motivering, tenzij Handyhand dit op grond van de wet niet mag doen of de motivering de veiligheid van het Platform of een lopend onderzoek in gevaar zou brengen. Ieder Lid kan het lidmaatschap zonder opzegtermijn beëindigen via het menu “Instellingen”.",
        "P7": "2.7 Alleen personen van 18 jaar of ouder kunnen als Lid worden geregistreerd.",
        "P8": "2.8 Een Lid moet een natuurlijke persoon zijn, maar kan in het profiel aangeven een onderneming te vertegenwoordigen.",
        "P9": "2.9 Handyhand kan een persoon weigeren zich als Lid te registreren of het profiel van een bestaand Lid beperken, opschorten, wijzigen of beëindigen als aan de voorwaarden van punt 2.6 of 8.4.1 is voldaan. Een zakelijke Handyhander ontvangt bij permanente beëindiging of een wezenlijke beperking van de toegang tot het Platform in beginsel ten minste 30 dagen voorafgaande kennisgeving, tenzij een wettelijke uitzondering van toepassing is, bijvoorbeeld bij illegale inhoud, fraude, veiligheidsrisico's, herhaalde overtredingen of een andere dwingende reden.",
        "P10": "2.10 Registratie als Lid bij Handyhand is gratis. Er worden geen kosten in rekening gebracht voor het plaatsen en delen van een Klus of voor het openen, melden en bekijken van inhoud op het Handyhand-platform door andere Leden, waaronder het delen van Klussen."
      },
      "3": {
        "TITLE": "3. HET HANDYHAND-PLATFORM EN HET SLUITEN VAN KLUSOVEREENKOMSTEN",
        "TOC": "3. HET HANDYHAND-PLATFORM EN HET SLUITEN VAN KLUSOVEREENKOMSTEN",
        "P1": "3.1 Handyhand stelt het Handyhand-platform beschikbaar zodat Opdrachtgevers Klussen kunnen plaatsen en publiceren.",
        "P2": "3.2 De diensten van Handyhand bestaan uit het voortdurend beheren en onderhouden van het Handyhand-platform met als doel contact tot stand te brengen tussen Leden, waaronder Opdrachtgevers en Handyhanders.",
        "P3": "3.3 Handyhanders kunnen een bod uitbrengen op een gepubliceerde Klus. Bepaalde gegevens uit een bod kunnen openbaar worden gemaakt, ook aan internetgebruikers die geen Lid zijn.",
        "P4": "3.4 De Opdrachtgever kan een gepubliceerde Klus op elk moment intrekken of wijzigen voordat de Opdrachtgever een bod van een Handyhander aanvaardt. Handyhand behoudt zich het recht voor alle biedingen op een gepubliceerde Klus die vóór de wijziging zijn uitgebracht, te annuleren.",
        "P5": "3.5 Wanneer een Opdrachtgever via het Handyhand-platform een bod aanvaardt, komt de Klusovereenkomst tot stand tussen de Handyhander en de Opdrachtgever.",
        "P6": "3.6 Bij het sluiten van de Klusovereenkomst moet de Opdrachtgever ervoor zorgen dat de Klusprijs wordt gereserveerd of betaald via de door Handyhand gebruikte externe betalingsverwerker, momenteel Stripe, zodat de betaling tussen de Opdrachtgever en de Handyhander kan worden afgehandeld. De betalingsstroom wordt beheerd volgens de voorwaarden van de betalingsverwerker en de toepasselijke betalingsregelgeving.",
        "P7": "3.7 De bemiddelingsdienst van Handyhand geldt als uitgevoerd zodra de Klusovereenkomst via het Platform tot stand komt. De Bemiddelingsvergoeding wordt op dat moment verschuldigd, met inachtneming van punt 11. De Bemiddelingsvergoeding kan via de betalingsverwerker worden geïnd en binnen de betalingsstroom worden ingehouden, voor zover dit verenigbaar is met de voorwaarden van de betalingsverwerker en de toepasselijke wetgeving.",
        "P8": "3.8 Handyhand aanvaardt geen verantwoordelijkheid voor de uitvoering van de Klus. De Klusovereenkomst is uitsluitend bindend tussen de Handyhander en de Opdrachtgever.",
        "P9": "3.9 Nadat de Klusovereenkomst tot stand is gekomen, kunnen de Handyhander en de Opdrachtgever de Klusovereenkomst via het Handyhand-platform wijzigen. De Opdrachtgever en de Handyhander worden aangeraden het privéberichtensysteem van Handyhand te gebruiken om de Klusovereenkomst, waaronder de overeengekomen prijs, te wijzigen of aan te vullen en om met elkaar te communiceren.",
        "P10": "3.10 Wanneer de Klus is voltooid, moeten zowel de Handyhander als de Opdrachtgever dit via het Handyhand-platform melden.",
        "P10_1": "3.10.1 Wanneer de Handyhander de Klus als voltooid markeert, heeft de Opdrachtgever tien dagen om de voltooiing te bevestigen of via het Platform concreet en gemotiveerd bezwaar te maken. Als de Opdrachtgever de voltooiing bevestigt of niet binnen deze termijn reageert, kan de betaling via de betalingsverwerker aan de Handyhander worden vrijgegeven, onder inhouding van de Bemiddelingsvergoeding. Het vrijgeven van de betaling op grond van dit punt regelt uitsluitend het betalingsproces en verhindert de Opdrachtgever of de Handyhander niet om op grond van de Klusovereenkomst, dwingend recht of bij een bevoegde klachteninstantie of rechter aanspraken tegenover elkaar geldend te maken.",
        "P11": "3.11 Na beëindiging van de Klusovereenkomst worden de partijen aangemoedigd de diensten op het Handyhand-platform te beoordelen en feedback te geven."
      },
      "4": {
        "TITLE": "4. BEMIDDELINGSVERGOEDING",
        "TOC": "4. BEMIDDELINGSVERGOEDING",
        "P1": "4.1 Bij het sluiten van een Klusovereenkomst zijn de Handyhander en de Opdrachtgever ieder afzonderlijk hun betreffende deel van de Bemiddelingsvergoeding aan Handyhand verschuldigd. Deze wordt als volgt berekend:",
        "P1_LIST": {
          "1_LABEL": "Voor de Handyhander:",
          "1_LINK": "https://handyhand.$$domain$$/handyhander-niveaus",
          "2": "Voor de Opdrachtgever: $$taskOwnerFeePercent$$% van de Klusprijs, met een maximum van $$taskOwnerFeeMax$$"
        },
        "P2": "4.2 De Bemiddelingsvergoeding wordt automatisch geïnd wanneer de Klusprijs wordt afgeschreven en wordt ingehouden op het bedrag dat vanaf de Betaalrekening wordt uitbetaald.",
        "P3": "4.3 Als voor een Klus kosten moeten worden gemaakt door de Handyhander voor de uitvoering van de diensten, worden deze kosten niet meegenomen bij de berekening van vergoedingen.",
        "P4": "4.4 De vergoedingen omvatten geen kosten die aan externe dienstverleners verschuldigd kunnen zijn. Alle externe dienstverleners worden betaald op grond van de afzonderlijke overeenkomst tussen het Lid en de betreffende externe dienstverlener.",
        "P5": "4.5 Vergoedingen en andere bedragen die aan Handyhand moeten worden betaald, worden alleen terugbetaald voor zover dit volgt uit deze Algemene voorwaarden, dwingend recht of een uitdrukkelijke beslissing van Handyhand in het concrete geval.",
        "P6": "4.6 Handyhand kan bedragen die een Lid toekomen verrekenen, met dien verstande dat de verrekening geen betrekking mag hebben op gelden die op grond van toepasselijke wetgeving of de voorwaarden van de betalingsverwerker afgescheiden of beschermd moeten blijven.",
        "P7": "4.7 Handyhand kan de rekening van een Lid beperken totdat alle verschuldigde vergoedingen zijn betaald.",
        "P8_TITLE": "4.8 Rangschikking, zichtbaarheid en Handyhander-niveaus:",
        "P8_1": "4.8.1 De zichtbaarheid van Klussen, biedingen en Handyhanders op het Platform kan afhangen van verschillende parameters, waaronder relevantie voor de kluscategorie, geografische afstand, prijs, beschikbaarheid, reactietijd, voltooiingspercentage, annuleringsgeschiedenis, beoordelingen, verificaties, het Handyhander-niveau en eventuele veiligheids- of kwaliteitssignalen.",
        "P8_2": "4.8.2 De parameters worden gebruikt om relevante matches en een veilig en goed functionerend Platform te bevorderen. Handyhand kan de weging van de parameters voortdurend aanpassen, maar zal zakelijke Handyhanders overeenkomstig punt 14 informeren over wezenlijke wijzigingen.",
        "P8_3": "4.8.3 Als Handyhand betaalde promotie of een andere betaalde mogelijkheid voor extra zichtbaarheid aanbiedt, worden de belangrijkste voorwaarden daarvan op het Platform of in afzonderlijke voorwaarden vermeld."
      },
      "5": {
        "TITLE": "5. FACTURERING",
        "TOC": "5. FACTURERING",
        "P1": "5.1 Handyhand biedt via het Handyhand-platform een dienst aan waarbij automatisch facturen namens Handyhanders worden gegenereerd zodra is gemeld dat de Klus is uitgevoerd.",
        "P2": "5.2 Door de Algemene voorwaarden te aanvaarden, geven Handyhanders uitdrukkelijk toestemming aan Handyhand om namens hen facturen te genereren en uit te geven. Deze facturen bevatten de relevante gegevens die de betreffende Handyhander op het Handyhand-platform heeft ingevoerd.",
        "P3": "5.3 Het genereren van facturen via het Handyhand-platform is uitsluitend een technische en administratieve dienst. Voor alle duidelijkheid: Handyhand wordt daardoor geen partij bij de onderliggende overeenkomst tussen de Handyhander en de Opdrachtgever. Handyhand staat niet in voor de inhoud, juistheid, geldigheid of betaling van de factuur en aanvaardt geen verantwoordelijkheid voor facturering, wanbetaling of andere omstandigheden die verband houden met de betreffende Klus.",
        "P4": "5.4 Ieder geschil, iedere fout of iedere vordering met betrekking tot de factuur of de geleverde dienst moet uitsluitend tussen de Handyhander en de Opdrachtgever worden afgehandeld.",
        "P5": "5.5 De Handyhander is er zelf verantwoordelijk voor dat facturen die namens de Handyhander worden uitgegeven aan de toepasselijke wetgeving voldoen, waaronder fiscale, heffings- en boekhoudregels. Handyhand kan niet aansprakelijk worden gesteld voor directe of indirecte gevolgen van het niet naleven van de toepasselijke regels voor de inhoud van facturen."
      },
      "6": {
        "TITLE": "6. BETALINGEN EN TERUGBETALINGEN BIJ ANNULERING",
        "TOC": "6. BETALINGEN EN TERUGBETALINGEN BIJ ANNULERING",
        "P1": "6.1 Als de Klusovereenkomst, ongeacht de reden, vóór aanvang van de Klus door de Opdrachtgever of de Handyhander wordt geannuleerd, heeft Handyhand recht op annulerings- en administratiekosten ter hoogte van 10% van de Klusprijs, met een maximum van $$cancellationFeeMax$$ (de “Annuleringskosten”).",
        "P1_1": "6.1.1 Als de annulering plaatsvindt voordat het bedrag is afgeschreven, terwijl de Klusprijs dus alleen is gereserveerd, schrijft Handyhand een deel van de gereserveerde Klusprijs af ter hoogte van de Annuleringskosten en wordt de resterende reservering vrijgegeven.",
        "P1_2": "6.1.2 Als de annulering plaatsvindt nadat het bedrag is afgeschreven, wordt de Klusprijs aan de Opdrachtgever terugbetaald, onder aftrek van de Annuleringskosten.",
        "P2": "6.2 De Annuleringskosten komen voor rekening van de Opdrachtgever als de Klus op initiatief van de Opdrachtgever wordt geannuleerd of de annulering aan de Opdrachtgever kan worden toegerekend. De overeengekomen prijs wordt in dat geval aan de Opdrachtgever terugbetaald, onder aftrek van de Annuleringskosten. Een annulering van de Klusovereenkomst wordt aan de Opdrachtgever toegerekend wanneer:",
        "P2_LIST": {
          "1": "a) de Opdrachtgever de Klusovereenkomst annuleert; of",
          "2": "b) de Klusovereenkomst overeenkomstig punt 8.4.1 wordt geannuleerd als gevolg van handelen of contractbreuk door de Opdrachtgever."
        },
        "P2_1": "6.2.1 Voor het tijdstip van annulering zijn de punten 6.1.1 tot en met 6.1.2 van toepassing.",
        "P3": "6.3 De Annuleringskosten komen voor rekening van de Handyhander als de annulering aan de Handyhander kan worden toegerekend. Een annulering van de Klusovereenkomst wordt aan de Handyhander toegerekend wanneer:",
        "P3_LIST": {
          "1": "a) de Opdrachtgever en de Handyhander gezamenlijk overeenkomen de Klusovereenkomst te annuleren; of",
          "2": "b) de Klusovereenkomst door de Opdrachtgever wordt geannuleerd nadat de Opdrachtgever oprecht maar zonder succes heeft geprobeerd contact op te nemen met de Handyhander om de Klusovereenkomst te laten uitvoeren; of",
          "3": "c) de Handyhander de Klusovereenkomst annuleert; of",
          "4": "d) de Klusovereenkomst overeenkomstig punt 8.4.1 wordt geannuleerd als gevolg van handelen of contractbreuk door de Handyhander."
        },
        "P3_1": "6.3.1 Voor het tijdstip van annulering zijn de punten 6.1.1 tot en met 6.1.2 van toepassing.",
        "P4": "6.4 Ieder bedrag dat Handyhand op grond van punt 6.1 namens een Handyhander aan een Opdrachtgever terugbetaalt, vormt een schuld van de Handyhander aan Handyhand. Handyhand kan dit bedrag verrekenen met andere betalingen die op enig moment aan de Handyhander verschuldigd zijn.",
        "P5": "6.5 Iedere openstaande Annuleringskosten die een Lid op grond van punt 6.1 aan Handyhand verschuldigd is, kan door Handyhand op elk moment worden verrekend met andere betalingen die Handyhand aan het Lid verschuldigd is.",
        "P6": "6.6 Als de Opdrachtgever recht heeft op terugbetaling, vindt de terugbetaling in beginsel plaats via het betaalmiddel dat voor de betaling is gebruikt, tenzij de Opdrachtgever er uitdrukkelijk voor kiest het bedrag als opgeslagen tegoed op het Platform te ontvangen. De Opdrachtgever aanvaardt dat Handyhand of de betalingsverwerker maximaal 14 dagen nodig kan hebben om de terugbetaling te verwerken. Opgeslagen tegoed kan voor toekomstige Klussen worden gebruikt. De Opdrachtgever kan verzoeken om uitbetaling van ongebruikt opgeslagen tegoed, tenzij dwingend recht, de voorwaarden van de betalingsverwerker of meegedeelde en aanvaarde inhoudingen anders bepalen. Opgeslagen tegoed dat niet is gebruikt of waarvan de Opdrachtgever niet om uitbetaling heeft verzocht, vervalt drie jaar nadat het tegoed is aangemaakt, tenzij dwingend recht anders bepaalt."
      },
      "7": {
        "TITLE": "7. MARKETING",
        "TOC": "7. MARKETING",
        "P1": "7.1 Directe of verborgen reclame en iedere andere vorm van marketing door Leden op het Platform, voor zichzelf of voor anderen, is niet toegestaan.",
        "P2": "7.2 Iedere handeling in strijd met punt 7.1 geldt als een wezenlijke tekortkoming in de overeenkomst tussen Handyhand en het Lid. Handyhand behoudt zich het recht voor inhoud van het Platform te verwijderen en verdere juridische stappen te nemen die Handyhand als gevolg van de overtreding van punt 7.1 noodzakelijk acht."
      },
      "8": {
        "TITLE": "8. VERPLICHTINGEN VAN DE LEDEN",
        "TOC": "8. VERPLICHTINGEN VAN DE LEDEN",
        "P1_TITLE": "8.1 Gezamenlijke verplichtingen:",
        "P1_1": "8.1.1 Het Lid verplicht zich:",
        "P1_1_LIST": {
          "1": "a) alle toepasselijke wet- en regelgeving na te leven, waaronder bijzondere regels die van toepassing kunnen zijn op de uitvoering van de Klus. Handyhand draagt hiervoor geen verantwoordelijkheid;",
          "2": "b) uitsluitend juiste informatie op het Handyhand-platform te delen."
        },
        "P1_2": "8.1.2 Het Lid aanvaardt dat al het materiaal op het Handyhand-platform, ongeacht of dit door Handyhand, een Lid of een derde is geplaatst, niet door derden of voor andere commerciële doeleinden mag worden gebruikt zonder voorafgaande schriftelijke toestemming van Handyhand.",
        "P1_3": "8.1.3 Het Lid mag het Handyhand-platform niet voor illegale of immorele doeleinden gebruiken.",
        "P1_4": "8.1.4 Het lidmaatschap en de toegang tot de Handyhand-rekening zijn persoonlijk. Het Lid moet te allen tijde de volledige controle over de Handyhand-rekening behouden. Het Lid mag anderen de rekening niet laten gebruiken en de rekening of de inhoud daarvan niet verkopen of anderszins aan anderen overdragen. Dit verhindert niet dat een Handyhander overeenkomstig punt 8.3.6 hulpkrachten, werknemers, onderaannemers of een vervanger inzet voor de uitvoering van een Klus.",
        "P1_5": "8.1.5 Alle informatie, gegevens, materialen en andere communicatie die het Lid via het Handyhand-platform deelt, moeten juist en actueel zijn en waar nodig worden bijgewerkt. Het Lid staat ervoor in en erkent dat het geen gegevens verstrekt die hiermee in strijd zijn, waaronder, maar niet uitsluitend, gegevens die:",
        "P1_5_LIST": {
          "1": "a) vals, onwaar, misleidend of bedrieglijk zijn;",
          "2": "b) frauduleus of bedrieglijk kunnen worden geacht of betrekking hebben op de verkoop van namaakgoederen of gestolen goederen;",
          "3": "c) inbreuk maken op auteursrechten, octrooien, merken, bedrijfsgeheimen of andere eigendomsrechten, intellectuele-eigendomsrechten, publiciteitsrechten, vertrouwelijkheid of privacy van derden;",
          "4": "d) in strijd zijn met wet- of regelgeving, besluiten of voorschriften, waaronder, maar niet beperkt tot, regels inzake export- en importcontrole, consumentenrechten, strafrecht en antidiscriminatie;",
          "5": "e) lasterlijk, bedreigend of intimiderend zijn;",
          "6": "f) obsceen zijn of materiaal bevatten dat Handyhand als ongepast of illegaal kan beschouwen, waaronder, maar niet beperkt tot, aanstootgevende, ongepaste of illegale afbeeldingen; of",
          "7": "g) kwaadaardige code, gegevens of instructies bevatten die het Handyhand-platform direct of indirect kunnen beschadigen of ondermijnen, waaronder, maar niet beperkt tot, computervirussen, Trojaanse paarden, wormen, tijdbommen, cancelbots, easter eggs of andere programmeerroutines die systemen, gegevens of persoonsgegevens kunnen beschadigen, wijzigen, verwijderen, verstoren, heimelijk blokkeren, zonder toestemming openen of onteigenen."
        },
        "P1_6": "8.1.6 Het Handyhand-platform kan op elk moment locatiediensten of kaart- en locatiefunctionaliteit gebruiken. Handyhand kan de locatie tonen van Opdrachtgevers en Handyhanders die het Platform gebruiken. Een Lid mag nooit persoonsgegevens, zoals de volledige naam, het exacte adres, telefoonnummer of e-mailadres, vermelden in de titel, beschrijving, commentaarvelden of op andere plaatsen waar communicatie op het Handyhand-platform openbaar toegankelijk is.",
        "P2_TITLE": "8.2 Verplichtingen van Opdrachtgevers:",
        "P2_1": "8.2.1 Opdrachtgevers moeten alle noodzakelijke en relevante informatie verstrekken zodat Handyhanders een bod kunnen uitbrengen en de Klus vervolgens kunnen uitvoeren.",
        "P2_2": "8.2.2 Opdrachtgevers moeten ervoor zorgen dat Handyhanders de toegang en toestemming krijgen die nodig zijn om de diensten overeenkomstig de Klusovereenkomst te leveren.",
        "P2_3": "8.2.3 Opdrachtgevers moeten Handyhand informeren over wijzigingen in Klusovereenkomsten die leiden tot prijswijzigingen in de verhouding tussen de Opdrachtgever en de Handyhander.",
        "P2_4": "8.2.4 Opdrachtgevers moeten alle verschuldigde bedragen tijdig aan zowel Handyhand als de Handyhanders betalen.",
        "P3_TITLE": "8.3 Verplichtingen van Handyhanders:",
        "P3_1": "8.3.1 De Handyhander moet beschikken over de vereiste vaardigheden, toestemmingen, certificaten en vergunningen en moet anderszins gerechtigd zijn de overeengekomen diensten op grond van Klusovereenkomsten uit te voeren of te leveren.",
        "P3_2": "8.3.2 De Handyhander moet voldoen aan alle fiscale en wettelijke verplichtingen met betrekking tot betalingen die in verband met een Klusovereenkomst worden ontvangen.",
        "P3_3": "8.3.3 De Handyhander is verplicht Handyhand te vrijwaren tegen iedere vordering, ieder verlies, alle kosten en andere uitgaven of nadelen waarmee Handyhand door een derde of een Opdrachtgever in verband met de uitvoering van de Klus wordt geconfronteerd.",
        "P3_4": "8.3.4 De Handyhander mag bij het leveren van diensten geen vergoedingen of andere betalingen boven op de overeengekomen prijs aan de Opdrachtgever in rekening brengen. De partijen bij een Klusovereenkomst kunnen via het Handyhand-platform wel overeenkomen de overeengekomen prijs te wijzigen.",
        "P3_5": "8.3.5 Als een Handyhander ermee instemt kosten te maken voor de uitvoering van een Klus, zoals de aanschaf van benodigdheden voor de diensten die onder de Klus vallen, is de Handyhander zelf verantwoordelijk voor het verkrijgen van betaling daarvan door de Opdrachtgever. Handyhand aanvaardt geen enkele verantwoordelijkheid voor dergelijke kosten.",
        "P3_6": "8.3.6 De Handyhander bepaalt in ieder opzicht zelf hoe een Klusovereenkomst wordt uitgevoerd en kan daarom werknemers, hulpkrachten, onderaannemers of een vervanger inzetten voor de uitvoering van de Klus of een deel daarvan. De toegang tot de Handyhand-rekening mag niet aan anderen worden overgedragen of beschikbaar worden gesteld.",
        "P3_7": "8.3.7 De Handyhander voert Klussen uit als zelfstandige en bepaalt zelf of, wanneer en onder welke voorwaarden de Handyhander op Klussen wil bieden. Handyhand geeft de Handyhander geen instructies over de wijze waarop de Klus moet worden uitgevoerd. De Handyhander bepaalt zelf het bod en de prijs tegenover de Opdrachtgever.",
        "P4_TITLE": "8.4 Overtredingen:",
        "P4_1": "8.4.1 Als Handyhand van oordeel is dat een Lid punt 8, een Klusovereenkomst of de overige Algemene voorwaarden heeft overtreden, kan Handyhand evenredige maatregelen nemen. Handyhand kan onder meer een waarschuwing geven, de zichtbaarheid beperken, inhoud verwijderen, functies opschorten, relevante Klussen of biedingen annuleren, de rekening tijdelijk opschorten of het lidmaatschap beëindigen.",
        "P5_TITLE": "8.5 Platformbeslissingen, meldingen en klachten:",
        "P5_1": "8.5.1 Leden kunnen inhoud, Klussen, profielen, berichten of gedrag op het Platform melden als zij menen dat deze illegaal zijn of in strijd zijn met de Algemene voorwaarden. Meldingen worden ingediend via de ingebouwde meldfunctie van het Platform. Is dat niet mogelijk, dan kan contact worden opgenomen met Handyhand via $$contactUrl$$. Een melding moet bij voorkeur een beschrijving van de situatie, de locatie van de inhoud en relevante documentatie bevatten.",
        "P5_2": "8.5.2 Als Handyhand besluit inhoud te verwijderen, de zichtbaarheid te beperken, een rekening op te schorten, een lidmaatschap te beëindigen of de toegang tot het Platform anderszins te beperken, verstrekt Handyhand het Lid een duidelijke en concrete motivering. Dit geldt niet als Handyhand de motivering op grond van de wet niet mag geven of als de motivering de veiligheid van het Platform of een lopend onderzoek in gevaar zou brengen.",
        "P5_3": "8.5.3 Het Lid kan via $$contactUrl$$ contact opnemen met Handyhand om een Platformbeslissing te laten heroverwegen. Handyhand streeft ernaar dergelijke verzoeken binnen een redelijke termijn te behandelen en kan na een concrete beoordeling de beslissing handhaven, wijzigen of intrekken.",
        "P5_4": "8.5.4 Voor zakelijke Handyhanders geldt daarnaast dat Handyhand, voor zover relevant, de belangrijkste redenen voor een beperking, opschorting of beëindiging vermeldt en in beginsel voorafgaande kennisgeving geeft. Handyhand kan van voorafgaande kennisgeving afzien, bijvoorbeeld bij illegale inhoud, fraude, veiligheidsrisico's, herhaalde overtredingen of een andere dwingende reden.",
        "P5_5": "8.5.5 Voor zover Handyhand daartoe op grond van de toepasselijke wetgeving verplicht is, of Handyhand dit in het concrete geval aanvaardt, kan worden geprobeerd een geschil tussen een zakelijke Handyhander en Handyhand door middel van mediation op te lossen. Deze bepaling beperkt de toegang van partijen tot de rechter niet."
      },
      "9": {
        "TITLE": "9. ROL EN AANSPRAKELIJKHEID VAN HANDYHAND",
        "TOC": "9. ROL EN AANSPRAKELIJKHEID VAN HANDYHAND",
        "P1": "9.1 Handyhand bemiddelt uitsluitend via het Handyhand-platform bij de Klus tussen de Opdrachtgever en de Handyhander. Handyhand is daarom geen partij bij de overeenkomst voor de uitvoering van de Klus.",
        "P2": "9.2 De planning, uitvoering en verantwoordelijkheid voor Klussen berusten uitsluitend bij de Opdrachtgever en de Handyhander. Handyhand draagt daarom geen verantwoordelijkheid voor de uitvoering van de Klus of voor de rechten en verplichtingen van de Opdrachtgever en de Handyhander op grond van de Klusovereenkomst.",
        "P3": "9.3 Het Lid en de Opdrachtgever erkennen en aanvaarden daarom uitdrukkelijk dat Handyhand op geen enkele wijze aansprakelijk is voor schade die ontstaat tijdens de uitvoering van Klussen, gebreken in de uitvoering van een Klus of het niet voltooien van een Klus, met inachtneming van punt 18.",
        "P4": "9.4 Het Lid erkent en aanvaardt daarnaast dat Handyhand niet aansprakelijk kan worden gesteld voor het gebruik of de verstrekking door anderen van gegevens op de website van Handyhand.",
        "P5": "9.5 De bemiddelingsdienst van Handyhand is voltooid wanneer de Klusovereenkomst via het Platform tot stand komt, overeenkomstig de punten 3.7 en 11. Het markeren van een Klus als voltooid regelt uitsluitend het betalingsproces tussen de Opdrachtgever en de Handyhander en verhindert partijen op zichzelf niet om op grond van de Klusovereenkomst of dwingend recht aanspraken tegenover elkaar geldend te maken.",
        "P6": "9.6 Handyhand draagt geen verantwoordelijkheid voor informatie die door andere Leden van het Platform beschikbaar wordt gesteld, waaronder, maar niet beperkt tot, de bekwaamheid of vergunningen van Handyhanders om Klussen uit te voeren, informatie van Opdrachtgevers of het vermogen van een Opdrachtgever om voor de gevraagde diensten te betalen.",
        "P7": "9.7 Handyhand is niet verplicht civielrechtelijke conflicten of geschillen tussen Leden te beslechten. Handyhand kan wel het betalingsproces beheren en overeenkomstig punt 10 een praktisch geschilproces faciliteren, zonder daardoor partij te worden bij de Klusovereenkomst of verantwoordelijkheid te aanvaarden voor de uitvoering van de Klus.",
        "P8": "9.8 Het Lid begrijpt en aanvaardt dat Handyhand geen onderzoek uitvoert naar nieuwe Leden of externe dienstverleners voordat zij toegang krijgen tot het Handyhand-platform. Dit omvat onder meer achtergrondonderzoek, controle van strafregisters, verificatie van vergunningen of bevoegdheden van het Lid en ieder ander onderzoek naar het karakter van het Lid of diens vermogen om Klussen uit te voeren die het Lid op het Handyhand-platform zegt te kunnen uitvoeren. Het Lid begrijpt en aanvaardt dat het uitsluitend zelf verantwoordelijk is voor relevant achtergrondonderzoek en het verkrijgen van referenties, beoordelingen, verificaties, vergunningen en verzekeringen voordat een ander Lid met werkzaamheden of diensten begint. Het Lid is uitsluitend zelf verantwoordelijk voor alle eigen beoordelingen en beslissingen bij de keuze van een Lid om een Klus uit te voeren. Het Lid aanvaardt het volledige risico en vrijwaart Handyhand tegen ieder verlies, iedere schade, aansprakelijkheid, ieder letsel, overlijden en andere kosten die in verband met de dienstverlening ontstaan.",
        "P9": "9.9 Handyhand kan niet aansprakelijk worden gesteld voor inhoud op het Handyhand-platform, waaronder met name tekst, informatie en links die door Leden in vrije tekstvelden op de website zijn geplaatst.",
        "P10": "9.10 Handyhand kan niet aansprakelijk worden gesteld voor directe of indirecte verliezen of gevolgschade, waaronder gederfde inkomsten of verlies van gegevens en informatie."
      },
      "10": {
        "TITLE": "10. GESCHILLEN",
        "TOC": "10. GESCHILLEN",
        "P1": "10.1 Handyhand moedigt Leden aan geschillen, waaronder verzoeken om terugbetaling of restitutie, rechtstreeks met elkaar op te lossen. Voor zover dit noodzakelijk en evenredig is om de uitvoering van de Klus, geschilbehandeling, veiligheid of naleving van wet- en regelgeving te faciliteren, kan Handyhand relevante contact- en klusgegevens verstrekken aan andere Leden die bij het geschil betrokken zijn. Meer informatie over de verwerking van persoonsgegevens is opgenomen in het privacybeleid van Handyhand.",
        "P2": "10.2 Als tussen Leden een geschil ontstaat, moeten de Leden samenwerken en oprecht proberen het geschil op te lossen.",
        "P3": "10.3 Als de Opdrachtgever binnen de termijn van punt 3.10.1 concreet en gemotiveerd bezwaar maakt, kan de betaling tijdelijk via de betalingsverwerker worden vastgehouden, voor zover dit volgens de regels van de betalingsverwerker en het toepasselijke recht mogelijk is, terwijl de Leden proberen het geschil op te lossen. Handyhand kan de partijen om relevante documentatie vragen en kan het betalingsproces beheren op basis van objectieve, redelijke en evenredige criteria, waaronder de documentatie van de partijen, de status van de Klus, communicatie op het Platform, eerdere bevestigingen, de regels van de betalingsverwerker, het risico op fraude of misbruik en deze Algemene voorwaarden. Handyhand neemt geen definitieve juridische beslissing over de wederzijdse aanspraken van de partijen. Als de partijen het geschil niet binnen 30 dagen na het bezwaar oplossen, kan Handyhand na voorafgaande kennisgeving de reservering vrijgeven en/of het bedrag terugstorten aan de Opdrachtgever. Handyhand kan de termijn tot in totaal 60 dagen verlengen als daarvoor bijzondere redenen bestaan."
      },
      "11": {
        "TITLE": "11. HERROEPINGSRECHT",
        "TOC": "11. HERROEPINGSRECHT",
        "P1": "11.1 Consumenten hebben ten aanzien van de bemiddelingsdienst van Handyhand in beginsel een herroepingsrecht op grond van de Deense regels voor consumentenovereenkomsten, tenzij het herroepingsrecht volgens die regels en de procedure van punt 11.2 vervalt.",
        "P2": "11.2 Bij het sluiten van een Klusovereenkomst stemt het Lid ermee in dat Handyhand de bemiddelingsdienst vóór het einde van de herroepingstermijn begint te leveren. Het herroepingsrecht vervalt zodra de bemiddelingsdienst van Handyhand volgens de Algemene voorwaarden volledig is geleverd. Vanaf dat moment kan de Bemiddelingsvergoeding van Handyhand niet worden teruggevorderd. Het Lid erkent uitdrukkelijk dat het herroepingsrecht vervalt wanneer de bemiddelingsdienst van Handyhand volledig is geleverd.",
        "P3": "11.3 Deze bepaling doet geen afbreuk aan een eventueel herroepingsrecht in de verhouding tussen Leden die een Klusovereenkomst hebben gesloten."
      },
      "12": {
        "TITLE": "12. BERICHTEN AAN LEDEN",
        "TOC": "12. BERICHTEN AAN LEDEN",
        "P1": "12.1 Handyhand kan Leden serviceberichten, operationele berichten en berichten over de rekening van het Lid, Klussen, betalingen, veiligheid en wijzigingen van de Algemene voorwaarden sturen. Marketingberichten worden alleen verzonden als het Lid daarvoor afzonderlijk toestemming heeft gegeven of als het bericht anderszins op grond van de toepasselijke wetgeving is toegestaan."
      },
      "13": {
        "TITLE": "13. GEGEVENSBESCHERMING",
        "TOC": "13. GEGEVENSBESCHERMING",
        "P1": "13.1 Handyhand verwerkt de persoonsgegevens van Leden zoals beschreven in het privacybeleid van Handyhand. Bepaalde gegevens, waaronder naam, profielgegevens, klusgegevens, beoordelingen en relevante contactgegevens, kunnen aan andere Leden beschikbaar worden gesteld voor zover dit noodzakelijk is voor het gebruik van het Platform, het sluiten en uitvoeren van Klusovereenkomsten, de veiligheid, geschilbehandeling of naleving van wet- en regelgeving. Handyhand verwerkt niet meer persoonsgegevens dan voor deze doeleinden noodzakelijk is.",
        "P2": "13.2 Om uitbetalingen te ontvangen, kan het Lid worden gevraagd de identiteit en rekening te verifiëren bij de betalingsverwerker van Handyhand, momenteel Stripe. Voor zover identiteitsdocumenten worden verwerkt, gebeurt dit volgens de voorwaarden van de betalingsverwerker en het privacybeleid van Handyhand. Handyhand bewaart dergelijke documenten niet langer of in ruimere mate dan noodzakelijk en wettelijk toegestaan.",
        "P3": "13.3 Handyhand zal voor zover mogelijk de nodige maatregelen nemen om ervoor te zorgen dat de door Leden verstrekte lidmaatschapsgegevens niet in ruimere mate aan andere Leden beschikbaar zijn dan noodzakelijk voortvloeit uit het bedrijfsmodel van Handyhand voor het aanbieden van Klussen. Lidmaatschapsgegevens worden daarnaast niet aan derden verstrekt. Het Lid stemt er wel mee in dat lidmaatschapsgegevens voor interne, statistische en geanonimiseerde beoordelingsdoeleinden worden gebruikt.",
        "P4": "13.4 Een Lid kan zijn lidmaatschapsgegevens op elk moment wijzigen of het profiel en daarmee alle opgeslagen gegevens verwijderen via het menu “Profiel bewerken”.",
        "P5": "13.5 Een Lid kan het lidmaatschap op elk moment beëindigen door via $$contactUrl$$ contact op te nemen met Handyhand."
      },
      "14": {
        "TITLE": "14. WIJZIGINGEN VAN DE ALGEMENE VOORWAARDEN",
        "TOC": "14. WIJZIGINGEN VAN DE ALGEMENE VOORWAARDEN",
        "P1": "14.1 Handyhand behoudt zich het recht voor de Algemene voorwaarden te wijzigen.",
        "P2": "14.2 Bij wezenlijke wijzigingen van de Algemene voorwaarden worden de Leden hierover per e-mail of op een andere duidelijke manier geïnformeerd. De wijziging wordt ook op de website van Handyhand vermeld. Zakelijke Handyhanders ontvangen in beginsel ten minste 15 dagen voorafgaande kennisgeving, tenzij de wijziging noodzakelijk is wegens wet- en regelgeving, veiligheidsoverwegingen, technische omstandigheden of een andere dwingende reden."
      },
      "15": {
        "TITLE": "15. BETALINGSVERWERKER",
        "TOC": "15. BETALINGSVERWERKER",
        "P1": "15.1 Handyhand gebruikt een externe betalingsverwerker, momenteel Stripe, om betalingen te ontvangen, uitbetalingen te verrichten en de betalingsstroom tussen Leden overeenkomstig deze Algemene voorwaarden te ondersteunen. Het Lid aanvaardt de relevante voorwaarden van de betalingsverwerker, die hier zijn te vinden: https://stripe.com/en-US/connect-account/legal. De betalingsstroom is onderworpen aan de regels van de betalingsverwerker, KYC-vereisten, sanctiecontroles, risicobeoordelingen en de toepasselijke betalingsregelgeving."
      },
      "16": {
        "TITLE": "16. COOKIES",
        "TOC": "16. COOKIES",
        "P1": "16.1 Handyhand gebruikt cookies en andere identificatietechnologieën op het Handyhand-platform voor verschillende doeleinden, waaronder het verifiëren van Leden, het begrijpen van algemeen online gedrag, het onthouden van gebruikersvoorkeuren en instellingen en het analyseren van verkeer, trends op de website en interesses van Leden.",
        "P2": "16.2 Het Lid kan ervoor kiezen cookies wel of niet te aanvaarden.",
        "P3": "16.3 De meeste webbrowsers zijn standaard ingesteld om cookies te aanvaarden. Het Lid kan de browser meestal zo instellen dat browsercookies worden verwijderd of geweigerd. Volg hiervoor de instructies van de browser, die doorgaans te vinden zijn in het menu “Help” of “Instellingen”."
      },
      "17": {
        "TITLE": "17. OVERIGE BEPALINGEN",
        "TOC": "17. OVERIGE BEPALINGEN",
        "P1": "17.1 Als een of meer bepalingen van de Algemene voorwaarden zonder werking zijn of niet uitvoerbaar blijken, zijn de partijen verplicht rechtmatige maatregelen te nemen die zo veel mogelijk tot hetzelfde of een vergelijkbaar resultaat leiden.",
        "P2": "17.2 Als een of meer bepalingen van de Algemene voorwaarden zonder werking zijn of niet uitvoerbaar blijken, heeft dit geen invloed op de geldigheid van de overige bepalingen.",
        "P3": "17.3 Ieder geschil tussen Handyhand en een Lid wordt beheerst door $$jurisdiction$$ recht."
      },
      "18": {
        "TITLE": "18. FINANCIËLE TEGEMOETKOMING",
        "TOC": "18. FINANCIËLE TEGEMOETKOMING",
        "P1": "18.1 Als uitzonderlijke service biedt Handyhand de Opdrachtgever een financiële tegemoetkoming van maximaal $$compensationMax$$ aan indien:",
        "P1_LIST": {
          "1": "a) naar het discretionaire oordeel van Handyhand voldoende is aangetoond dat het door de Handyhander uitgevoerde werk gebreken vertoont;",
          "2": "b) de Opdrachtgever naar het discretionaire oordeel van Handyhand aantoonbaar verlies heeft geleden; en",
          "3": "c) het aangetoonde verlies meer bedraagt dan $$compensationMin$$."
        },
        "P2": "18.2 De financiële tegemoetkoming op grond van punt 18.1 is uitzonderlijk en wijzigt niet het uitgangspunt dat Handyhand niet afzonderlijk aansprakelijk kan worden gesteld voor de uitvoering van de Klus. De tegemoetkoming kan in geen geval meer bedragen dan $$compensationMax$$.",
        "P3": "18.3 Een financiële tegemoetkoming op grond van punt 18.1 kan alleen door de Opdrachtgever worden gevraagd als de Klus volledig via het Handyhand-platform is betaald. Als de Klus geheel of gedeeltelijk buiten de betaaloplossingen van Handyhand om wordt betaald, is Handyhand niet verplicht de Opdrachtgever enige financiële tegemoetkoming te bieden.",
        "P4": "18.4 Als Handyhand overeenkomstig punt 18.1 een financiële tegemoetkoming aan de Opdrachtgever uitbetaalt, behoudt Handyhand zich het recht voor een vordering op de betreffende Handyhander in te stellen ter hoogte van de aan de Opdrachtgever betaalde tegemoetkoming, mede gelet op punt 18.2.",
        "P5": "18.5 Een verzoek om financiële tegemoetkoming op grond van punt 18.1 moet uiterlijk 30 dagen na de uitvoering van het werk schriftelijk bij Handyhand worden gemeld. Daarna vervalt de mogelijkheid een financiële tegemoetkoming te ontvangen.",
        "P6": "18.6 Geschillen tussen Handyhand en de Opdrachtgever over een eventuele goodwillvergoeding moeten in onderling overleg worden opgelost. Als geen minnelijke oplossing kan worden gevonden, wordt het geschil overeenkomstig punt 17.3 beslist, tenzij dwingende consumentenrechtelijke regels over de bevoegde rechter anders bepalen.",
        "READ_MORE": "Lees hier meer over wanneer deze vergoeding wel en niet kan worden gebruikt"
      }
    }
  }
}
